// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colours */
  --primaryColor: #1d9f86;
  --primaryColorOpacity: #1d9f8534;
  --secondaryColor: #b6bb34;
  --secondaryColorOpacity: #b6bb3444;
  --secondaryColorLight: #dee0b9;
  --thirdColor: #215257;
  --fourthColour: #739092;
  --darkColour: #132530;
  --lightGrey: #e8e8e8;
  /* #eaeaea; */
  --mediumGrey: #cccccc;
  --darkGrey: #a3a3a3;
  --fontColor: #000000;
  --fontLightColor: #fff;
  --errorColor: #db0000;
  --errorColorLight: #eec4c4;
  --errorHoverColor: #b91313;
  --warningColor: #ff9616;
  --warningColorLight: #ffe7c5;
  --warningHoverColor: #f67b00;
  --trHover: #e8e9c8;
  --shadow: 0px 2px 6px #00000041;

  /* Fonts */
  --headingFont: 'Open Sans', sans-serif;
  --copyFont: 'Open Sans', sans-serif;

  /* Font sizes */
  --copySize: 14px;
  --h1Size: 28px;
  --h3Size: 22px;
  --h5Size: 16px;
  --letterSpacingHeading1: 0.5px;
  --letterSpacingHeading2: 0.2px;
  --letterSpacingCopy: 0.3px;
}

/* ---------------------------------------------------------------- */

* {
  box-sizing: border-box;
  margin: 0;
}

html {
  scroll-behavior: smooth;
}

div {
  font-family: var(--copyFont);
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.3px;
}

.body {
  display: grid;
  grid-template-columns: 100vw;
  /* 1fr */
  min-height: 100vh;
  align-content: space-between;
  overflow: hidden;
}

h1 {
  margin: unset;
  font-family: var(--headingFont);
  font-size: var(--h1Size);
  font-weight: bold;
  margin-bottom: 10px;
  color: var(--primaryColor);
  letter-spacing: var(--letterSpacingHeading1);
  line-height: 35px;
  width: fit-content;
}

h2 {
  margin: unset;
  font-family: var(--headingFont);
  font-size: var(--h1Size);
  color: var(--secondaryColor);
  margin-bottom: 10px;
  letter-spacing: var(--letterSpacingHeading1);
  line-height: 35px;
}

h3 {
  margin: unset;
  font-family: var(--headingFont);
  font-size: var(--h3Size);
  font-weight: 600;
  color: var(--primaryColor);
  margin-top: 0px !important;
  letter-spacing: var(--letterSpacingHeading2);
  margin-bottom: 1rem;
}

h4 {
  margin: unset;
  font-family: var(--headingFont);
  font-size: var(--h3Size);
  font-weight: 600;
  color: var(--fontColor);
  margin-bottom: 1rem;
  letter-spacing: var(--letterSpacingHeading2);
}

h5 {
  margin: unset;
  font-family: var(--headingFont);
  font-size: var(--h5Size);
  color: var(--primaryColor);
  margin-bottom: 0.8rem;
  letter-spacing: var(--letterSpacingHeading2);
  line-height: 26px;
  font-weight: 600;
}

h6 {
  margin: unset;
  font-family: var(--headingFont);
  font-size: var(--h5Size);
  /* color: var(--secondaryColor); */
  margin-bottom: 0.8rem;
  letter-spacing: var(--letterSpacingHeading2);
  line-height: 26px;
  font-weight: 600;
}

p {
  color: var(--copyColor);
  font-family: var(--copyFont);
  font-size: var(--copySize);
  letter-spacing: var(--letterSpacingCopy);
  line-height: 22px;
  font-weight: 400;
}

/* Tablet */
@media only screen and (max-width: 768px) {
  h1,
  h2 {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 18px;
    letter-spacing: var(--letterSpacingHeading1);
    line-height: 35px;
  }

  h3,
  h4 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    letter-spacing: var(--letterSpacingHeading2);
  }

  h5,
  h6 {
    font-size: 14px;
    line-height: 20px;
  }

  p {
    font-size: 12px;
    line-height: 21px;
  }

  div {
    font-family: var(--copyFont);
    font-weight: 600;
    font-size: 12px;
    line-height: 21px;
    letter-spacing: 0.3px;
  }
}

/* Mobile */
@media only screen and (max-width: 480px) {
  h1,
  h2 {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 18px;
    letter-spacing: var(--letterSpacingHeading1);
    line-height: 35px;
  }

  h3,
  h4 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    letter-spacing: var(--letterSpacingHeading2);
  }

  h5,
  h6 {
    font-size: 12px;
    margin-bottom: 8px;
    line-height: 22px;
  }

  p {
    font-size: 10px;
    line-height: 18px;
  }

  div {
    font-family: var(--copyFont);
    font-weight: 600;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0.3px;
  }
}

.instructionP {
  color: var(--darkGrey);
}

.greyBG {
  color: #7b7b7b;
  padding: 3rem;
  width: 100vw;
}

.instructionP {
  color: #7b7b7b;
}

hr {
  border: 1.5px solid var(--lightGrey);
  background-color: var(--lightGrey);
  margin: 0px 0px 30px 0px;
  width: 100%;
}

.greyBG hr {
  border: 1.5px solid var(--mediumGrey);
  background-color: var(--mediumGrey);
  margin: 20px 0px;
  width: 100%;
}

.formHR {
  border: 1.5px solid var(--primaryColor) !important;
  background-color: var(--primaryColor) !important;
  margin: 2rem 0px;
  width: 100%;
}

.vr {
  border-left: 2px solid #fff;
  height: 20px;
  margin: 0 15px;
}

ul {
  padding: 0.5rem 0;
}

ol {
  padding: 0.5rem 0;
}

.hide {
  display: none !important;
}

/* Loader */
/* #loader {
    display: none;
    position: fixed;
    left: 43%;
    top: 45%;
    z-index: 10;
    border: 16px solid var(--lightGrey);
    border-radius: 50%;
    border-top: 16px solid var(--primaryColor);
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}

#loaderOverlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.61);
    z-index: 9;

} */

#borderQA {
  pointer-events: none;
  border: 0.5rem solid red;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 101;
}

#loader {
  position: fixed;
  top: 0;
  z-index: 101;
  background-color: rgba(0, 0, 0, 0.68);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  /* justify-content: flex-start; */
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  color: white;
}

#spinner {
  position: fixed;
  /* left: 43%; */
  /* top: 45%; */
  z-index: 10;
  border: 16px solid var(--lightGrey);
  border-radius: 50%;
  border-top: 16px solid var(--primaryColor);
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

#loaderMsg {
  position: absolute;
  margin-top: 10rem;
}

#loader1 {
  display: block;
  position: absolute;
  left: 43%;
  top: 45%;
  z-index: 12;
  border: 16px solid var(--lightGrey);
  border-radius: 50%;
  border-top: 16px solid var(--primaryColor);
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.smallBox {
  background-color: var(--primaryColorOpacity);
  border-radius: 10px;
  padding: 2rem;
}

.smallBox > input {
  border-bottom: 2px solid var(--darkGrey);
}

.btn {
  font-family: var(--copyFont);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: var(--letterSpacingCopy);
  color: var(--fontLightColor);
  fill: var(--fontLightColor);
  padding: 12px 25px;
  background-color: var(--primaryColor);
  border: none;
  border-radius: 11px;
  cursor: pointer;
  text-transform: none;
  min-width: 170px;
  justify-content: center;
  align-items: center;
}

.btn:hover {
  background-color: var(--secondaryColor);
  border: none;
  outline: none;
}

.btnCancel {
  font-family: var(--copyFont);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: var(--letterSpacingCopy);
  color: var(--primaryColor);
  fill: var(--primaryColor);
  padding: 12px 25px;
  background-color: transparent;
  border: none;
  border-radius: 11px;
  border: solid 2px var(--primaryColor);
  cursor: pointer;
  text-transform: none;
  min-width: 170px;
  justify-content: center;
  align-items: center;
  margin: 0 1rem 1rem 1rem;
}

.btnCancel:hover {
  cursor: pointer;
  background-color: var(--mediumGrey);

  outline: none;
}

#loginBtn:disabled,
#forgotPassBtn:disabled {
  background-color: var(--mediumGrey);
}

.btn:disabled {
  background-color: var(--mediumGrey);
  cursor: not-allowed;
}

.btnText {
  transition: all 0.2s;
}

/* change btn text visibility */
.invisible {
  visibility: hidden;
  opacity: 0;
}

/* btn onclick loading animation  */
.btnLoading::after {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  /* top: 0;
    left: 0;
    right: 0;
    bottom: 0; */
  margin: auto;
  border: 4px solid transparent;
  border-top-color: var(--fontLightColor);
  border-radius: 50%;
  animation: btnLoading-spinner 1s ease infinite;
}

@keyframes btnLoading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}

.btn2 {
  font-family: var(--copyFont);
  font-size: 15px;
  color: white;
  padding: 14px 30px;
  background-color: var(--secondaryColor);
  border: none;
  border-radius: 11px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px !important;
  cursor: pointer;
  text-transform: none;
}

.btn2:hover {
  background-color: var(--thirdColor);
  border: none;
  outline: none;
  color: var(--primaryColor);
}

.errBtn {
  font-family: var(--copyFont);
  font-size: 15px;
  color: white;
  padding: 14px 42px;
  background-color: var(--errorColor);
  border: none;
  border-radius: 21px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  margin: auto;
  cursor: pointer;
  justify-content: center;
  text-transform: none;
}

.errBtn:hover {
  background-color: var(--errorHoverColor);
}

.clearBtn {
  position: relative;
  border: none;
  border-radius: 5px;
  background-color: transparent;
  cursor: pointer;
  color: rgb(82, 82, 82);
  box-shadow: none;
  min-width: 100px;
}

.clearBtn:hover {
  font-weight: bold;
}

.clearBtn svg {
  fill: rgb(82, 82, 82);
  height: 11px;
}

.subBtn {
  border: none;
  border-radius: 5px;
  background-color: var(--secondaryColor);
  cursor: pointer;
  color: white;
  padding: 10px 20px;
  box-shadow: none;
  text-align: center;
  width: auto;
}

.subBtn:hover {
  color: white;
  background-color: var(--secondaryColor);
  box-shadow: none;
  border: none;
}

.btnEndGrid {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  /* margin-top: 30px; */
}

.btnCenterGrid {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
}

.btnCenterGrid > button:first-child {
  margin: 0 1rem 1rem 0;
}

.btnCenterGrid > button:last-child {
  margin: 0 0 1rem 0;
}

.btnSVG {
  font-family: var(--copyFont);
  font-size: 13px;
  font-weight: 400;
  letter-spacing: var(--letterSpacingCopy);
  color: var(--fontLightColor);
  fill: var(--fontLightColor);
  padding: 11px 20px;
  background-color: var(--thirdColor);
  border: none;
  border-radius: 11px;
  cursor: pointer;
  min-width: 150px;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
}

.btnSVG:hover {
  background-color: var(--secondaryColor);
}

.btnSVG > svg {
  height: 17px;
  width: auto;
  margin-right: 5px;
}

.actionBtn {
  background-color: var(--lightGrey);
  color: var(--primaryColor);
  fill: var(--fontLightColor);
  font-family: var(--copyFont);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: var(--letterSpacingCopy);
  width: fit-content;
  padding-right: 1rem;
  border: none;
  border-radius: 11px;
  cursor: pointer;
  min-width: 150px;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 1rem;
}

.actionBtn > span:first-child {
  background-color: var(--primaryColor);
  border-radius: 11px 0 0 11px;
  margin-right: 1rem;
  height: inherit;
  display: flex;
  align-items: center;
  padding: 0px 0.8rem;
}

.actionBtn:hover {
  background-color: var(--mediumGrey);
}

#reactivateBtn {
  margin-bottom: 0;
  margin-left: 1rem;
}

.linkOpenTab {
  color: var(--primaryColor);
  text-decoration: underline;
  cursor: pointer;
  display: inline-flex;
  margin-left: 0.5rem;
}

.linkOpenTab svg {
  width: 20px;
  height: auto;
  /* padding-top: 5px; */
  margin-left: 0.2rem;
}

.greyBG {
  background-color: var(--lightGrey);
}

.width100 {
  width: 100%;
}

.responsivePadding {
  display: grid;
  grid-template-columns: minmax(auto, 1200px);
  justify-content: center;
  justify-items: center;
}

.responsiveHeading {
  display: grid;
  grid-template-columns: minmax(auto, 1200px);
  justify-content: center;
  justify-items: start;
  padding: 2rem 0 0 0;
  margin: 1rem 4rem;
}

.inlineTableHeading {
  margin: 1rem 4rem;
  padding: 2rem 0 0 0;
}

.responsiveHeadingTable {
  display: grid;
  /* grid-template-columns: minmax(auto, 1200px); */
  margin: 0 4rem;
  justify-content: start;
  justify-items: start;
  padding: 2rem 0 0 0;
}

@media only screen and (max-width: 1300px) {
  .responsivePadding {
    grid-template-columns: 1fr;
    padding: 0 3rem;
  }

  .responsiveHeading {
    grid-template-columns: 1fr;
    padding: 2rem 3rem 0 3rem;
  }
}

@media only screen and (max-width: 600px) {
  .responsivePadding {
    grid-template-columns: 1fr;
    padding: 0 2rem;
  }

  .responsiveHeading {
    grid-template-columns: 1fr;
    padding: 1rem 2rem 0 2rem;
  }
}

.grid-1col-input {
  display: grid;
  grid-template-columns: minmax(auto, 800px);
  justify-items: start;
  margin: 0 2rem;
}

.grid-1col {
  display: grid;
  grid-template-columns: minmax(auto, 1200px);
  justify-items: start;
}

.grid-2col {
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  justify-items: center;
  margin: 0 2rem;
}

.grid-3col {
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem;
  align-items: center;
  justify-items: center;
  margin: 0 2rem;
}

.grid-2col-input {
  display: grid;
  justify-content: center;
  grid-template-columns: 320px 320px;
  gap: 10px 160px;
}

@media only screen and (max-width: 910px) {
  .grid-2col-input {
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr;
    gap: 10px 0px;
  }

  .grid-2col {
    grid-template-columns: 1fr;
    gap: 3rem;
    margin: 0 2rem;
  }

  .grid-1col {
    margin: 0 2rem;
  }

  .group {
    width: 100%;
  }

  .row > .group {
    width: 100% !important;
    margin: 0 2rem 1rem 0 !important;
  }

  .row {
    flex-direction: column !important;
  }

  .row .marginLeft {
    margin-left: unset;
  }
}

.grid-2col-input-custard {
  display: grid;
  justify-content: center;
  grid-template-columns: 320px 320px;
  gap: 2rem;
  margin-top: 3rem;
}

@media only screen and (max-width: 1155px) {
  .grid-2col-input-custard {
    grid-template-columns: 320px;
    gap: 2rem;
  }
}

.row {
  display: flex;
  flex-direction: row;
  margin: 0;
  flex-wrap: wrap;
  /* margin-bottom: 20px; */
}

.float {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: left;
}

.floatItem {
  margin-right: 35px;
  margin-bottom: 20px;
}

.marginTop {
  margin-top: 1.5rem;
}

.marginBottom {
  margin-bottom: 1.5rem;
}

.sectionGap {
  margin-bottom: 3rem;
}

.marginLeft {
  margin-left: 3rem;
}

.marginRight {
  margin-right: 3rem;
}

/*================================ INPUT====================== */
.group {
  position: relative;
  margin-bottom: 34px;
  width: 100%;
}

.row > .group {
  width: unset;
  margin: 0 2rem 3rem 0;
}

.inptAddBtnDiv {
  display: flex;
  align-items: flex-start;
}

.inptAddBtnDiv button {
  margin-left: 10px;
  padding: 6px 10px;
}

.inptAddBtnDiv img {
  height: 17px;
  margin-top: 3px;
}

input {
  font-family: var(--copyFont);
  font-size: 14px;
  padding: 7px 7px 7px 5px;
  letter-spacing: var(--letterSpacingCopy);
  display: block;
  width: 310px;
  border: none;
  border-bottom: 2px solid var(--mediumGrey);
  margin-bottom: 8px;
  background-color: #0000;
  /* padding-left: 38px; */
}

select {
  font-family: var(--copyFont);
  font-size: 14px;
  padding: 7px 7px 7px 5px;
  letter-spacing: var(--letterSpacingCopy);
  display: block;
  width: 310px;
  border: none;
  border-bottom: 2px solid var(--mediumGrey);
  margin-bottom: 8px;
  background-color: transparent;
}

select[multiple] {
  border: 2px solid var(--mediumGrey);
  background-color: white;
  margin-top: 1rem;
}

select[multiple]:focus {
  border: 2px solid var(--primaryColor);
}

option {
  color: var(--darkColour);
  /* background-color: white; */
}

textarea {
  font-family: var(--copyFont);
  font-size: 14px;
  padding: 7px 7px 7px 5px;
  letter-spacing: var(--letterSpacingCopy);
  width: 100%;
  height: 120px;
  border: 2px solid var(--mediumGrey);
  padding: 10px;
  font: var(--copyFont);
  letter-spacing: var(--letterSpacingCopy);
  font-weight: 400;
  margin-top: 10px;
}

input:focus {
  outline: none;
}

select:focus {
  outline: none;
  border-bottom: 2px solid var(--primaryColor);
}

select:hover {
  cursor: pointer;
}

textarea:focus {
  outline: none;
  border: 2px solid var(--primaryColor);
}

input[type='password'] {
  letter-spacing: 1.1px;
}

input[type='radio'] {
  cursor: pointer;
  width: fit-content;
}

input[type='file'] {
  display: none;
}

.borderInput {
  border: 2px solid var(--mediumGrey);
  border-radius: 7px;
  /* height: 40px; */
}

a {
  /* margin-top: 5px; */
  color: var(--fontColor);
  text-decoration: none;
}

a:hover {
  cursor: pointer;
}

/* Chrome, Safari, Edge, Opera - no arrows */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox - no arrows */
input[type='number'] {
  -moz-appearance: textfield;
}

/* i>img {
    width: 24px;
    top: 10px;
    position: absolute;
} */

/* LABEL ======================================= */
label {
  font-family: var(--copyFont);
  color: var(--darkGrey);
  font-size: 14px;
  font-weight: normal;
  letter-spacing: var(--letterSpacingCopy);
  /* pointer-events: none; */
  left: 7px;
  top: 7px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.group > label {
  position: absolute;
}

/* active state */
input:valid ~ label,
select:valid ~ label,
textarea:valid ~ label {
  top: -15px;
  font-size: 12px;
  left: 0px;
  color: var(--darkGrey);
  font-weight: 400;
  letter-spacing: 0.5px;
}

label {
  top: -15px;
  font-size: 12px;
  left: 0px;
  color: var(--darkGrey);
  font-weight: 400;
  letter-spacing: 0.5px;
}

input:invalid ~ label,
select:invalid ~ label,
textarea:invalid ~ label {
  top: -15px;
  font-size: 12px;
  left: 0px;
  color: var(--darkGrey);
  font-weight: 400;
  letter-spacing: 0.5px;
}

input:focus ~ label,
select:focus ~ label,
textarea:focus ~ label {
  top: -15px;
  font-size: 12px;
  left: 0px;
  color: var(--primaryColor);
  font-weight: 400;
  letter-spacing: 0.5px;
}

.labelDescript {
  font-size: 10px;
  color: var(--darkColour);
  text-transform: none;
  font-weight: 500;
  margin-bottom: 10rem;
  position: relative;
}

/* BOTTOM BARS ================================= */
.bar {
  position: relative;
  display: block;
  width: 310px;
}

.bar:before,
.bar:after {
  content: '';
  height: 3px;
  width: 0;
  bottom: 7px;
  position: absolute;
  background: var(--primaryColor);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.bar:before {
  left: 50%;
}

.bar:after {
  right: 50%;
}

/* active state */
input:focus ~ .bar:before,
input:focus ~ .bar:after {
  width: 50%;
}

.primaryColor {
  color: var(--primaryColor);
  fill: var(--primaryColor);
}

.errorColor {
  color: var(--errorColor);
  fill: var(--errorColor);
}

.secondColor {
  color: var(--secondaryColor);
  fill: var(--primaryColor);
}

.warningColor {
  color: var(--warningColor);
  fill: var(--warningColor);
}

.bold {
  font-weight: bold !important;
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from {
    background: var(--secondColor);
  }

  to {
    width: 0;
    background: transparent;
  }
}

@-moz-keyframes inputHighlighter {
  from {
    background: var(--secondColor);
  }

  to {
    width: 0;
    background: transparent;
  }
}

@keyframes inputHighlighter {
  from {
    background: var(--secondColor);
  }

  to {
    width: 0;
    background: transparent;
  }
}

.inpFB {
  position: absolute;
  font-size: 10px;
  color: var(--errorColor);
  top: 36px;
}

input[type='checkbox'] {
  width: auto !important;
  min-width: 18px;
  height: 18px;
  cursor: pointer;
  z-index: 2;
}

input[type='radio'] {
  width: auto !important;
}

input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
  cursor: pointer;
  height: 18px;
  width: 18px;
  /* content: url(../assets/img/icons/clearSearch.svg); */
}

.newEntry {
  /* border-color: var(--secondaryColor) !important; */
  margin-top: 10px;
}

/* Upload button  - 2 part*/
.uploadbtn {
  border: none;
  border-radius: 5px;
  background-color: #dedede;
  cursor: pointer;
  font-size: 12px !important;
  color: var(--primaryColor) !important;
  margin: 5px 5px;
  padding: 10px 0px 10px 20px;
  height: 40px;
  width: fit-content;
}

.uploadbtn:hover {
  background-color: #cacaca;
}

.uploadAdd {
  background-color: var(--primaryColor);
  font-size: 25px;
  color: white;
  margin-left: 10px;
  border-radius: 0px 5px 5px 0px;
  padding: 3px 7px 0px 7px;
  margin-top: 5px;
  vertical-align: middle;
  align-items: center;
  height: 40px;
}

/* ---------- */
/* checkbox */
/* Customize the label (the container) */
.checkContainer {
  all: unset;
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

label.checkContainer {
  line-height: 17px;
  font-size: 14px;
  width: auto;
  cursor: pointer;
}

label.checkContainer p {
  /* font-weight: 300; */
  font-size: 12px;
}

/* Create a custom checkbox */
.tick {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: transparent;
  border: 2px solid var(--primaryColor);
}

/* On mouse-over, add a grey background color */
.checkContainer:hover input ~ .tick {
  background-color: #e6e6e6;
}

/* When the checkbox is checked, add a blue background */
.checkContainer input:checked ~ .tick {
  background-color: var(--primaryColor);
}

/* Create the tick/indicator (hidden when not checked) */
.tick:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the tick when checked */
.checkContainer input:checked ~ .tick:after {
  display: block;
}

/* Style the tick/indicator */
.checkContainer .tick:after {
  left: 4px;
  top: -1px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.addInfoBox {
  background-color: #f5f5f5;
  border-radius: 13px;
  padding: 2.5rem 2rem 1px 2rem;
  width: min-content;
  margin-top: 1.5rem;
  position: relative;
  right: 34px;
}

.addInfoBox > .group {
  margin-bottom: 3.2rem;
}

.addInfoBox > .group:last-child {
  margin-bottom: 2rem;
}

@media only screen and (max-width: 910px) {
  .addInfoBox {
    width: 100%;
    position: relative;
    right: unset;
  }
}

.radioDescript {
  top: -15px;
  font-size: 12px;
  left: 0px;
  color: var(--darkGrey);
  font-weight: 400;
  letter-spacing: 0.5px;
  position: absolute;
}

.radioLabel {
  position: unset !important;
  display: flex;
  margin-top: 1rem;
  margin-right: 1rem;
  align-items: center;
  color: var(--fontColor);
  cursor: pointer;
  font-size: var(--copyFont);
}

.radioLabel > input[type='radio'] {
  margin: 0 0.7rem 0 0;
  accent-color: var(--primaryColor);
}

/* Toggle */

/* The switch - the box around the slider */
.switch {
  all: unset;
  position: relative;
  display: inline-block;
  margin: 0 1rem 0.5rem 0;
  width: 50px;
  height: 24px;
  vertical-align: middle;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The toggle */
.toggle {
  width: 50px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.toggle.both {
  background-color: var(--secondaryColor);
}

.tgglLable {
  all: unset;
  font-size: var(--copySize) !important;
  color: var(--darkColour) !important;
  position: relative;
  top: -4px;
}

.toggle:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .toggle {
  background-color: var(--primaryColor);
}

input:checked + .toggle:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.toggle.round {
  border-radius: 34px;
}

.toggle.round:before {
  border-radius: 50%;
}

/* ------ */

/* Validation */

.correct {
  border-color: var(--primaryColor);
}

.incorrect {
  border-color: var(--errorColor) !important;
}

.incorrect:focus {
  border-color: var(--errorColor) !important;
}

/* =========== TABLE ============== */

table {
  border-spacing: 1;
  border-collapse: collapse;
  overflow: hidden;
  border: none;
  white-space: normal !important;
  margin: 0 4rem;
  box-shadow: var(--shadow);
  width: -webkit-fill-available;
  border-radius: 11px;
  background-color: white;
  margin-bottom: 40px;
}

table .btn {
  width: fit-content;
  min-width: unset;
  font-size: 13px;
}

thead {
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  letter-spacing: 0.2px;
  border: none;
  padding: 0px 20px !important;
  height: 65px;
}

th {
  font-size: 14px !important;
  font-weight: 600;
  border: none !important;
  padding: 15px 5px !important;
  font-family: var(--copyFont);
  font-size: var(--h5Size);
  color: white;
  margin-bottom: 13px;
  letter-spacing: var(--letterSpacingCopy);
  background-color: var(--primaryColor);
  text-align: center;
  padding: 20px;
  position: relative;
}

td {
  padding: 15px !important;
  font-family: var(--copyFont);
  font-size: 13px;
  color: var(--copyColor);
  letter-spacing: var(--letterSpacingCopy);
  line-height: 20px;
  padding: 20px;
  font-weight: 400;
  text-align: center;
  width: auto;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
}

tr {
  border-bottom: 2px solid #e6e6e6 !important;
  font-size: 13px !important;
  background-color: #ffffff;
  padding: 15px 15px !important;
  text-transform: none !important;
  white-space: normal !important;
}

tr:hover {
  background-color: var(--trHover);
}

#mailBody > tr:hover {
  background-color: none !important;
}

table tr:last-of-type {
  border-bottom: none;
}

#text table {
  box-shadow: none !important;
  margin: none !important;
  background-color: none;
}

#text tr {
  border-bottom: none !important;
}

#text td {
  padding: 0.5rem !important;
}

.grid-1col table,
.grid-1col-input table {
  margin: 0 0 2rem 0;
}

.grid-2col table {
  margin: 0 0 2rem 0;
  width: 100%;
}

.grid-2col-input table {
  margin: 0 0 3rem 0;
  width: 100%;
}

td > table {
  background-color: white !important;
  width: -webkit-fill-available !important;
  margin-left: 0 !important;
  margin: 0.5rem 1rem !important;
}

.center {
  display: flex;
  justify-content: center;
}

.middle {
  display: flex;
  align-items: center;
}

.tableIcon {
  margin-left: 12px;
}

table img,
table svg {
  fill: var(--primaryColor);
  max-height: auto;
  width: 20px;
}

.tableImage {
  width: auto;
}

.tableIcon svg {
  fill: var(--primaryColor);
  height: 23px;
  width: auto;
}

.iconSize {
  max-height: auto;
  width: 20px;
}
/*     const svgElement = await svgStringParse(dragDotsSVG);
    barLefts.forEach((bar) => {
      bar.prepend(svgElement.cloneNode(true)); */

/* ------Pagination -------- */

#pagDiv {
  text-align: center;
  margin: 15px;
}

.pagNum {
  font-size: 12px;
  font-weight: normal;
  color: #000000;
  position: relative;
  border: none;
  border-radius: 5px;
  background-color: transparent;
  cursor: pointer;
  padding: 10px 20px;
  box-shadow: none;
}

.pagNumActive {
  font-size: 14px;
  font-weight: bold;
  position: relative;
  border: none;
  border-radius: 5px;
  background-color: var(--secondaryColor);
  cursor: pointer;
  color: black;
  padding: 10px 20px;
  box-shadow: none;
}

.pagNum:hover {
  font-weight: bold;
}

.pagArrow {
  color: #000000;
  position: relative;
  border: none;
  border-radius: 5px;
  background-color: transparent;
  cursor: pointer;
  padding: 10px 20px;
  box-shadow: none;
  font-size: 20px;
}

.pagArrow:hover {
  color: var(--primaryColor);
}

/* ------Search Table --------------- */

#searchSpace {
  display: flex;
  justify-content: flex-end;
  margin: 1rem 4rem;
}

#genSearch {
  border: 2px solid var(--mediumGrey);
  border-radius: 7px;
  padding-left: 33px;
  height: 40px;
}

#searchFilters {
  width: auto;
  height: 40px;
  background-color: var(--primaryColor);
  border-radius: 7px;
  margin-left: 12px;
  text-align: center;
  top: -5px;
  position: relative;
  padding: 0px 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  cursor: pointer;
  margin-top: 5px;
}

#searchFilters > img {
  width: 17px;
  height: auto;
  margin-left: 10px;
  /* margin-top: 12px; */
}

#searchFilters:hover {
  background-color: var(--secondaryColor);
}

.searchFiltersActive {
  background-color: var(--secondaryColor) !important;
}

.searchBarIcon {
  /* content: url(../assets/img/icons/magGlass_grey.svg); */
  width: 14px;
  fill: var(--darkColour);
  position: absolute;
  margin: 13px;
}

#trSearch {
  background-color: #e8e8e8 !important;
  /* #DEDEDE */
  min-height: 65px;
}

#trSearch input {
  min-width: 130px;
  max-width: 180px;
  margin: 10px;
}

#trSearch select {
  min-width: 130px;
  max-width: 175px;
  margin: 10px;
}

.iconOff {
  fill: #777777;
  cursor: pointer;
}

.iconOn {
  fill: var(--primaryColor);
}

.iconGrid {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-items: center;
  grid-gap: 8px;
}

#iconGrid svg {
  cursor: pointer;
}

.clientLogoTable > img {
  width: 60px;
  height: auto;
}

.iconTable,
.iconTable > svg {
  width: 30px;
  height: auto;
  fill: var(--primaryColor);
}

/* ----------- Select Client ---------------------- */

#selectC {
  background-color: var(--primaryColorOpacity);
  border-radius: 10px;
  padding: 1.5rem 2rem;
  margin-bottom: 30px;
  margin-top: 2rem;
  width: 100%;
}

#selectC select {
  border-color: var(--darkGrey);
}

.selectCGrid {
  display: grid;
  grid-template-columns: 1fr 1fr 0.5frs 1fr;
  grid-gap: 15px 20px;
  box-sizing: content-box;
}

#addToUserGroup {
  grid-column: 4/5;
  grid-row: 1;
}

#newGroupNameDiv {
  grid-column: 1;
  grid-row: 2;
}

#newGroupDescription {
  grid-column: 2;
  grid-row: 2;
}

#privateGroup {
  grid-column: 3;
  grid-row: 2;
}

.selectCHeading {
  font-family: var(--headingFont);
  font-size: 21px;
  color: var(--primaryColor);
  font-weight: normal;
}

.flex {
  display: flex;
  align-items: center;
}

/* =========== LOGIN ============== */

/*--------------- Login & Forgot Password------------*/

.loginGrid {
  position: absolute;
  display: grid;
  grid-template-columns: 10% 40% 40% 10%;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-items: center;
  z-index: 11;
  overflow: hidden;
}

#coverImg {
  min-height: 100vh;
  width: auto;

  background-position: center;
  background-repeat: no-repeat;
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  background-size: contain;
  z-index: 10;

  grid-column: 1 / span all;
  grid-row: 1 / span all;

  /* position: fixed;
    top: 0;
    left: 0;*/
}

.loginContent {
  grid-column: 3/4;
  grid-row: 1;
  width: 420px;
  height: fit-content;
  padding: 40px;
  background: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#loginLogos {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  justify-content: space-evenly;
  padding: 0;
  margin-bottom: 20px;
}

#loginLogos > img {
  height: 200px;
  width: 200px;
  max-height: 90px;
  max-width: 150px;
}

#loginDiv,
#forgotPassDiv {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}

#loginDiv > h1,
#forgotPassDiv > h1 {
  margin-bottom: 6px;
  font-size: 18px;
  font-weight: 600;
  color: var(--fontColor);
  margin-bottom: 2px;
}

#loginDiv > p,
#forgotPassDiv > p {
  font-size: 12px;
  margin-bottom: 22px;
  /* color: var(--darkGrey); */
  font-weight: 300;
}

.loginInputs {
  width: 100%;
}

.loginInputs > .group > input {
  width: 100%;
}

#langDivLogin {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

#langDivLogin > select {
  margin-bottom: unset;
}

#langDD {
  right: unset;
  width: fit-content;
  border-bottom: none;
  text-align: center;
  padding: 0px 2px;
}

.langLoginSVG {
  fill: black;
  position: relative;
}

#langDiv {
  display: flex;
  align-items: center;
}

.langHomeSVG {
  fill: white;
  position: relative;
  top: -3.5px;
}

.inputDarkGB {
  color: white;
  background-color: transparent;
}

#loginBtn,
#forgotPassBtn {
  background-color: var(--primaryColor);
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  max-width: unset;
  margin: 5px 0px 5px 0px;
  border-radius: 10px;
}

#ssoBtn {
  background-color: var(--secondaryColor);
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  max-width: unset;
  margin: 0.5rem 0;
  border-radius: 10px;
}

#ssoBtnDiv {
  width: 100%;
  display: flex;
  justify-content: center;
}

.loginHelp {
  color: var(--primaryColor);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0px;
  margin-top: 4px;
  cursor: pointer;
  font-style: italic;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.loginHelp:hover {
  font-weight: 600;
}

.loginHelp > span {
  display: flex;
  align-items: center;
}

#succSVG {
  fill: var(--primaryColor);
}

.ctick {
  fill: white;
}

.loginHelp > span > svg {
  fill: var(--primaryColor);
  height: 21px;
  margin-left: 3px;
  stroke-width: 0.4px;
  stroke: var(--primaryColor);
}

.forgotPassword {
  text-align: center;
  color: var(--primaryColor) !important;
  font-weight: normal;
}

.forgotPassword:hover {
  font-weight: bold;
}

/* Login Support */

.loginSupportGrid {
  position: absolute;
  display: grid;
  grid-template-columns: 5% 90% 5%;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-items: center;
  z-index: 11;
}

#supportBlock {
  grid-column: 2/3;
  grid-row: 1;
  width: 100%;
  height: fit-content;
  padding: 3rem;
  background: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  z-index: 11;
  display: grid;
  grid-template-columns: auto auto;
  gap: 80px;
}

#left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
}

.supportSpeel > h6 {
  font-weight: 400;
  line-height: 24px;
}

.supportSpeel p {
  font-size: 12px;
  line-height: 19px;
}

#right {
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
  gap: 5px 30px;
  align-content: center;
  margin-top: 15px;
}

.attachedFile {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--darkColour);
}

.attachedFile:hover {
  fill: var(--secondaryColor);
  color: var(--secondaryColor);
}

.attachedFile > svg {
  margin-right: 5px;
}

.fileNamePreview {
  display: flex;
  align-items: center;
  margin: 1rem 0;
  padding: 0.5rem 1rem;
  background-color: var(--lightGrey);
  width: 100%;
  justify-content: space-between;
  font-weight: 400;
}

#backLogin {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 2rem;
}

#backLogin:hover {
  color: var(--secondaryColor);
  fill: var(--secondaryColor);
}

#backLogin > svg {
  margin-right: 5px;
}

#backLogin > h6 {
  margin-bottom: 0;
}

#socialCU {
  display: flex;
  margin: 1rem 0;
}

#socialCU > svg,
#socialCU > a > svg {
  fill: var(--primaryColor);
  height: 17px;
  width: auto;
  margin-right: 15px;
}

#socialCU > svg:hover,
#socialCU > a > svg:hover {
  fill: var(--thirdColor);
  cursor: pointer;
}

/* =========== NAV ================ */

#nav {
  font-family: var(--copyFont);
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #ffffff;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto auto auto;
}

#bar1 {
  background-color: var(--darkColour);
  grid-column: 1 / span all;
  grid-row: 1;
}

#mobileNav {
  display: none;
}

#langUserDeesktop {
  grid-column: 1;
  grid-column-end: span all;
  grid-row: 1;
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 5px 10px;
  z-index: 1;
}

#userDD {
  background-color: white;
  box-shadow: var(--shadow);
  color: var(--fontColor);
  position: absolute;
  border-radius: 5px;
  right: 15px;
  margin-top: 4px;
  z-index: 2;
}

.userDDItem {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.userDDItem:first-child {
  border-radius: 5px 5px 0 0;
}

.userDDItem:last-child {
  border-radius: 0 0 5px 5px;
}

.userDDItem:hover {
  cursor: pointer;
  color: white;
  background-color: var(--secondaryColor);
  fill: white;
}

.chevron {
  fill: white;
  width: 13px;
  height: auto;
  margin-left: 5px;
}

.chevRotate {
  transform: rotate(180deg);
}

#userDD > hr {
  border: 1px solid var(--lightGrey);
  background-color: var(--lightGrey);
  /* margin: 10px 0px 10px 0px; */
  margin: 0;
}

.userDDItem > svg {
  margin-right: 10px;
  max-width: 20px;
  max-height: 20px;
}

#user {
  display: flex;
  align-items: center;
  align-content: center;
  cursor: pointer;
}

#userImg {
  border: 2px solid var(--secondaryColor);
  height: 21px;
  width: 21px;
  border-radius: 10px;
  margin-right: 5px;
}

#bar2 {
  background-color: var(--primaryColor);
  padding: 10px 30px;
  min-height: 55px;
  grid-column: 1 / span all;
  grid-row: 2;
}

.bar2SVG {
  height: 26px;
  width: auto;
  margin-right: 8px;
}

#logos {
  grid-column: 1/2;
  grid-row: 2;
  z-index: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
}

#logos > img {
  max-width: 125px;
  height: 32px;
  width: auto;
}

#candiNav {
  grid-column: 2 / 5;
  grid-row: 2;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
}

#adminNav {
  background-color: var(--lightGrey);
  grid-column: 1 / span all;
  grid-row: 3;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: 5px 30px;
  min-height: 55px;
  color: var(--darkColour);
}

#candiNav > div,
#adminNav > div {
  margin: 0 2rem;
  display: flex;
  align-items: center;
  fill: white;
  position: relative;
}

#adminNav > div {
  padding-bottom: 7px;
}

#candiNav > div:hover {
  fill: var(--darkColour);
  color: var(--darkColour);
  cursor: pointer;
}

#adminNav > div:hover {
  fill: var(--primaryColor);
  color: var(--primaryColor);
  cursor: pointer;
}

.adminSVG {
  fill: black;
  /* height: auto;
    width: 34px; */
  margin-right: 8px;
}

/* ==== SUBMENUS === */
#adminNav > div:hover .subMenu {
  display: block;
  transition-duration: 0.5s;
}

#adminNav > div:hover .subMenu:hover {
  display: block;
  fill: var(--primaryColor);
  color: var(--primaryColor);
}

.subMenu {
  position: absolute;
  display: none;
  /* fhjgek */
  top: 16px;
  background-color: #fff;
  box-shadow: var(--shadow);
  color: var(--fontColor);
  border-radius: 5px;
  margin-top: 4px;
  z-index: 2;
}

.subItem {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  color: var(--fontColor);
}

.subItem:hover {
  background-color: var(--secondaryColor);
  fill: var(--fontLightColor);
  color: var(--fontLightColor);
  border-radius: 5px;
}

.navActive {
  font-weight: bold;
  color: var(--secondaryColor);
}

.navActive > svg {
  fill: var(--secondaryColor);
}

.subMenu:hover .subSubMenu {
  display: block;
  transition-duration: 0.5s;
}

.subMenu:hover .subSubMenu:hover {
  display: block;
  fill: var(--primaryColor);
  color: var(--primaryColor);
}

.subSubMenu {
  position: relative;
  display: none;
  top: 0;
  /* right: -208px; */
  background-color: #fff;
  box-shadow: var(--shadow);
  color: var(--fontColor);
  border-radius: 5px;
  z-index: 2;
}

/* =========== FOOTER NAV ================ */
#footer {
  background-color: var(--darkColour);
  color: white;
  padding: 25px;
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-template-rows: auto auto;
  gap: 20px;
  align-self: end;
  justify-content: space-evenly;
}

#myDevDiv {
  grid-column: 4;
  grid-row: 1;
  margin-top: 30px;
}

#eFeedbackDiv {
  grid-column: 4;
  grid-row: 1;
}

#footer h6 {
  font-size: 14px;
  line-height: 16px;
}

#footer p {
  font-size: 12px;
}

#footer p:hover,
#footer h6:hover {
  color: var(--secondaryColor);
  cursor: pointer;
}

#contact {
  display: flex;
}

#contact div:first-of-type {
  margin-right: 20px;
}

#footerLogo {
  height: 110px;
}

#social {
  display: flex;
  margin-top: 21px;
}

#social > svg,
#social > a > svg {
  fill: white;
  height: 14px;
  width: auto;
  margin-right: 14px;
}

#social > svg:hover,
#social > a > svg:hover {
  fill: var(--secondaryColor);
  cursor: pointer;
}

#TCs {
  grid-column: 5;
  display: flex;
  align-items: flex-end;
}

#TCs > a {
  color: var(--fontLightColor);
  font-size: 10px;
  font-weight: 400;
  text-align: right;
  line-height: 14px;
  text-decoration: none;
}

#TCs > a:hover {
  color: var(--secondaryColor);
}

#TCs span {
  cursor: pointer;
}

/* =========== COOKIES POP-UP =========== */

#cookieBanner {
  z-index: 2;
  display: grid;
  grid-template-columns: auto auto;
  gap: 5px 40px;
  position: fixed;
  width: 80%;
  background-color: var(--secondaryColor);
  box-shadow: var(--shadow);
  padding: 1.5rem;
  border-radius: 10px;
  bottom: 5%;
}

#cookieSVG {
  height: 30px;
  width: auto;
  margin-right: 10px;
  margin-top: -10px;
}

.cookieBtn {
  font-family: var(--copyFont);
  font-size: 15px;
  color: white;
  padding: 14px 30px;
  background-color: var(--thirdColor);
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.cookieBtn:hover {
  background-color: var(--fourthColour);
  border: none;
  outline: none;
  color: white;
  font-weight: bold;
}

.cookieX {
  fill: var(--lightGrey);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 105 !important;
  margin-left: 20px;
  top: 12px;
  right: 12px;
}

.cookieX:hover {
  fill: var(--darkColour);
}

.pLink {
  font-weight: 600;
  cursor: pointer;
}

.inline {
  display: flex;
  align-items: center;
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.grid2 {
  display: grid;
  grid-template-columns: auto auto;
  gap: 80px;
  padding: 70px;
}

/* =============== NOTIFICATIONS ================= */
/* --------- Notification popup ------------------ */
.notify {
  position: fixed;
  top: 10px;
  z-index: 102;
}

.noteIcon > svg {
  fill: var(--primaryColor);
  width: 30px;
}

.noteX {
  color: var(--darkGrey);
  cursor: pointer;
}

.notification {
  position: relative;
  background: white;
  margin-top: 10px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 3%;
  left: -400px;
  min-width: 250px;
  max-width: 400px;
  min-height: 35px;
  border-right: solid;
  border-width: 5px;
  border-color: var(--primaryColor);
  font-size: 14px;
  opacity: 80%;
  display: grid;
  grid-template-columns: 15% 79% 6%;

  /* Animation – Slide in*/
  -webkit-animation: notification 0.5s forwards;
  -webkit-animation-delay: 1s;
  animation: notification 0.5s forwards;
  animation-delay: 1s;
}

@-webkit-keyframes notification {
  100% {
    left: 20px;
  }
}

@keyframes notification {
  100% {
    left: 20px;
  }
}

/* ---------------- Error popup -------------------- */
.popupBox {
  position: fixed;
  top: 30%;
  left: 40%;
  z-index: 100000;
}

.popupMsg {
  position: relative;
  background: white;
  box-shadow: 0px 3px 6px #00000029;
  padding: 10%;
  width: 300px;
  min-height: 200px;
  border-top: solid 8px var(--errorColor);
  font-size: 14px;
  text-align: center;
  z-index: 100000;
}

.msgHeading {
  font-size: 18px;
  font-weight: bold;
}

.popIconInfo > svg {
  fill: var(--primaryColor);
  width: 46px;
}

.popIconErr > svg {
  fill: var(--errorColor);
  width: 46px;
}

.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.61);
}

.invisibleOverlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  z-index: 1;
}

.invisibleOverlay:hover {
  background-color: transparent;
}

/* ----------information popup --------------------- */

.popupBoxBig {
  position: fixed;
  top: 30%;
  left: 40%;
  z-index: 100;
}

.popupBoxContent {
  position: relative;
  width: 80%;
  max-height: 90%;
  padding: 40px;
  top: 5%;
  margin: auto;
  background: white;
  margin-top: 10px;
  box-shadow: 0px 3px 6px #00000029;
  overflow: auto;
}

.seeThroughOverlay {
  position: fixed;
  width: 1000px;
  height: 100%;
  top: 150px;
  background-color: transparent;
  z-index: 101;
}

.closeX {
  padding-top: 7px;
  color: #dadada;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  float: right;
  position: relative;
  z-index: 105 !important;
  margin-left: 20px;
}

.closeX:hover {
  background-color: #e2e2e2;
  color: white;
  cursor: pointer;
}

/* ----------custom popup --------------------- */

#custardBox {
  position: fixed;
  top: 30%;
  left: 40%;
  z-index: 100;
}

#custardContainer {
  border-top: solid 8px var(--primaryColor);
  position: relative;
  width: 60%;
  max-height: 80%;
  padding: 40px;
  top: 15%;
  margin: auto;
  background: white;
  margin-top: 10px;
  box-shadow: 0px 3px 6px #00000029;
  overflow: auto;
}

#custardContent select {
  margin-bottom: 0;
}

#custardContent {
  text-align: center;
}

#custardContent .CCdigits {
  margin-bottom: 0;
}

#custardContent .bar {
  margin-top: 6px;
}

.x {
  fill: var(--mediumGrey);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  position: absolute;
  z-index: 105 !important;
  margin-left: 20px;
  top: 21px;
  right: 21px;
}

.x:hover {
  fill: var(--secondaryColor);
  cursor: pointer;
}

#passCust {
  margin-left: 2.5rem;
  margin-top: 3rem;
}

/* #passCust .viewPass {
    right: 90px;
} */

/* -----------Feedback Banner ----------*/
#feedbackBanner,
.feedbackBanner {
  background-color: #db00001c;
  border-left: 5px solid var(--errorColor);
  width: 100%;
  padding: 1rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 14px;
  align-items: center;
  text-align: left;
  justify-content: start;
  margin-bottom: 1rem;
}

.feedbackBannerGood {
  background-color: var(--primaryColorOpacity) !important;
  border-left: 5px solid var(--primaryColor) !important;
}

.feedbackBannerWarning {
  background-color: var(--warningColorLight) !important;
  border-left: 5px solid var(--warningColor) !important;
}

#feedback,
.feedback {
  color: var(--fontColor);
  font-size: 11px;
  line-height: 17px;
}

.xFeedback {
  fill: var(--darkGrey);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  z-index: 2;
  cursor: pointer;
}

.xFeedback:hover {
  fill: var(--fontColor);
}

/* =========== TABS =============== */

.tab {
  display: flex;
  padding-bottom: 0px;
  margin: 2.2rem 0px 20px 0px;
  width: 90%;
  overflow-x: auto;
  flex-direction: row;
  align-items: center;
}

.tab button.active {
  color: var(--fontColor);
  font-weight: 700;
  border-bottom: 3px solid var(--primaryColor);
  padding-bottom: 12px;
}

.tab button:hover {
  color: var(--secondaryColor);
  font-weight: 700;
}

.tab button {
  background-color: transparent;
  color: var(--darkGrey);
  /* min-width: 70px; */
  border: none;
  outline: none;
  cursor: pointer;
  margin-right: 35px;
  transition: 0.5s;
  font-family: var(--copyFont);
  letter-spacing: var(--letterSpacingCopy);
  white-space: nowrap;
}

.tabHR {
  width: 90%;
  position: relative;
  top: -23px;
  z-index: -1;
}

.scrollTabs {
  position: relative;
  width: 90%;
  overflow: hidden;
  cursor: pointer;
}

#leftScroll {
  left: 0;
  position: absolute;
  top: 50%;
}

#rightScroll {
  right: 0;
  position: absolute;
  top: 50%;
}

/* Tablet */
@media only screen and (max-width: 768px) {
  .tab button {
    font-size: 14px;
    line-height: 20px;
    background-color: transparent;
    color: var(--darkGrey);
    min-width: 50px;
    border: none;
    outline: none;
    cursor: pointer;
    margin-right: 1.5rem;
    transition: 0.5s;
    padding-bottom: 0.9rem;
  }
}

/* Mobile */
@media only screen and (max-width: 498px) {
  .tab button {
    font-size: 12px;
    line-height: 22px;

    margin-right: 1.4rem;
    transition: 0.5s;
    padding-bottom: 0rem;
  }
}

/* Country Code */

.CCdiv {
  display: grid;
  grid-template-columns: 100px auto;
}

.countryCodes {
  width: 100px;
  background-color: transparent;
  min-width: unset;
  padding-right: 4px;
  border: none;
  border-bottom: 2px solid var(--mediumGrey);
}

.CCdigits {
  border-radius: 0px 3px 3px 0px !important;
  border-left: none !important;
  min-width: unset !important;
  width: 209px;
  padding-left: 10px !important;
  /* margin-bottom: 0 */
}

/* Password Validation */
#passValBox,
#passMatchBox {
  width: auto;
  background-color: white;
  padding: 1rem;
  /* margin-top: 18px; */
  box-shadow: var(--shadow);
  position: relative;
  z-index: 1;
  top: -23px;
}

#passValBox:after,
#passMatchBox::after {
  content: '';
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  background: #fff;
  position: absolute;
  top: -10px;
  left: calc(10% - 10px);
  /* box-shadow: var(--shadow); */
}

#passValBox > ul {
  /* list-style-position: inside; */
  /* @steph */
  /* list-style-image: url(../assets/img/icons/cross.svg); */
  text-align: left;
  padding-left: 1rem;
}

li::marker {
  fill: var(--primaryColor);
  color: var(--primaryColor);
}

#passValBox > ul > li {
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
}

#passValBox > h5 {
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

#passMatchBox > h5 {
  color: var(--errorColor);
  margin-bottom: 0;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

/* tick & cross */
.SVGbullet {
  width: 10px;
}

/* eye */
.viewPass {
  width: 22px;
  height: auto;
  fill: var(--mediumGrey);
  position: absolute;
  cursor: pointer;
  right: 12px;
  top: 10px;
}

.iconOff {
  fill: var(--mediumGrey);
  cursor: pointer;
}

.iconOn {
  fill: var(--primaryColor);
}

#capsLock {
  width: 110px;
  background-color: #fff;
  padding: 5px;
  box-shadow: var(--shadow);
  position: absolute;
  z-index: 10;
}

#capsLock > h6 {
  font-size: 12px;
  z-index: 11;
  margin-bottom: 0;
}

#capsLock:after {
  content: '';
  width: 11px;
  height: 11px;
  transform: rotate(-45deg);
  background: #fff;
  position: absolute;
  top: -5px;
  left: calc(10% - -1px);
  /* box-shadow: var(--shadow); */
}

/* =========== HOMEPAGE =============== */

#intro {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-right: 50px;
  margin-top: 20px;
}

#myProfileLink {
  color: var(--primaryColor);
  cursor: pointer;
}

#myAssLink {
  font-weight: bold;
  cursor: pointer;
}

.smallCards {
  display: grid;
  margin: 2rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
  justify-content: center;
}

.gridSpan {
  grid-column: 1 / -1;
}

.card {
  background-color: white;
  box-shadow: var(--shadow);
  border-radius: 12px;
  display: grid;
  min-height: 100px;
  max-width: 300px;
  padding: 30px 20px 20px 20px;
  text-align: center;
  display: grid;
  align-content: stretch;
  grid-template-rows: 80px auto;
  justify-content: center;
}

.cardSVG {
  fill: var(--secondaryColor);
}

/* =========== PROFILE PAGE =============== */

.editImgBtn {
  cursor: pointer;
  z-index: 1;
  position: relative;
  top: 105px;
  left: 104px;
}

.profileImgContainer {
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  height: 150px;
  width: 150px;
  border: 3px solid var(--secondaryColor);
  background-color: var(--lightGrey);
  top: -40px;
  display: flex;
  justify-content: center;
}

.profileImgContainer > img {
  object-fit: cover;
  text-align: center;
}

.passwordBtn {
  font-family: var(--copyFont);
  letter-spacing: var(--letterSpacingCopy);
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  padding: 9px 18px;
  background-color: var(--primaryColor);
  border: none;
  border-radius: 11px;
  cursor: pointer;
  text-transform: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 227px;
}

/* 
#fake_password {
    width: 216px;
} */

.passwordBtn:hover {
  background-color: var(--secondaryColor);
  border: none;
  outline: none;
}

/* ======= TOOLTIP =============== */

.toolTip {
  position: relative;
  display: inline-block;
}

.toolTipText {
  visibility: hidden;
  width: inherit;
  background-color: var(--secondaryColor);
  color: var(--fontColor);
  /* box-shadow: var(--shadow); */
  text-align: center;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: 400;
  font-size: 10px;
  line-height: normal;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  left: 0;
  top: 2.5rem;
}

.toolTipText::after {
  content: '';
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  background-color: var(--secondaryColor);
  position: absolute;
  top: -0.5rem;
  left: calc(20% - 10px);
  /* box-shadow: var(--shadow); */
}

.toolTipTextTable {
  visibility: hidden;
  width: inherit;
  /* min-width: 70px; */
  background-color: var(--lightGrey);
  color: var(--fontColor);
  box-shadow: var(--shadow);
  text-align: center;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: 400;
  font-size: 10px;
  line-height: normal;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  left: -5px;
  top: 2.5rem;
}

.toolTipTextTable::after {
  content: '';
  width: 15px;
  height: 15px;
  transform: rotate(-45deg);
  background-color: var(--lightGrey);
  position: absolute;
  top: -0.4rem;
  left: calc(100% - 65%);
  /* box-shadow: var(--shadow); */
}

.test {
  left: 0;
  top: 3.5rem;
}

.toolTip:hover .toolTipText,
.toolTip:hover .toolTipTextTable {
  visibility: visible;
}

.iSVG,
.iSVG > path {
  fill: var(--fontLightColor) !important;
  height: 14px;
  width: auto;
  cursor: pointer;
}

.appTip {
  top: -10px;
  left: -165px;
  width: 150px;
  padding-left: 0.7rem;
  z-index: 100;
}

.appTip::after {
  content: '';
  width: 15px;
  height: 15px;
  transform: rotate(-45deg);
  background-color: var(--secondaryColor);
  position: absolute;
  top: 0.7rem;
  left: 142px;

  /* box-shadow: var(--shadow); */
}

/* ------- TOOL TIP INPUT NO HOVER */

.toolTip2 {
  position: relative;
  display: inline-block;
}

.toolTipText2 {
  visibility: visible;
  width: inherit;
  background-color: var(--secondaryColor);
  color: var(--fontColor);
  /* box-shadow: var(--shadow); */
  text-align: center;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: 400;
  font-size: 10px;
  line-height: normal;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  left: 0;
  top: 2.7rem;
}

.toolTipText2::after {
  content: '';
  width: 15px;
  height: 15px;
  transform: rotate(-45deg);
  background-color: var(--secondaryColor);
  position: absolute;
  top: -0.4rem;
  left: calc(20% - 10px);
  /* box-shadow: var(--shadow); */
}

/* =========== MY MESSAGES PAGE =============== */

.msgGrid {
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 0px;
  padding: 1rem;
  width: -webkit-fill-available;
  margin: 0 3rem 3rem 3rem;
}

/* Left */
#msgs {
  padding: 2rem;
  background-color: var(--lightGrey);
  border-radius: 11px;
}

#listMsgs {
  /* padding: 1rem; */
  margin: 0.5rem;
}

.msg {
  padding: 1rem;
  position: relative;
  border-radius: 11px;
  cursor: pointer;
}

.msg:hover {
  background-color: var(--primaryColorOpacity);
}

.msgActive {
  background-color: white;
  box-shadow: var(--shadow);
}

.msgActive:hover {
  background-color: white;
}

.msgDate {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 12px;
  color: var(--darkGrey);
}

.msgSubject {
  color: var(--primaryColor);
  margin-bottom: 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 12px;
  font-weight: 600;
}

.msgActive .msgSubject {
  color: var(--secondaryColor);
}

.msgPreview {
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* right */
#msgDetail {
  padding: 0 3rem;
}

#msgDDate {
  color: var(--mediumGrey);
  font-size: 13px;
}

#msgDSubject {
  margin: 0.8rem 0 !important;
}

#msgDWho > span {
  font-weight: 600;
}

#msgBack {
  display: none;
  margin-bottom: 1rem;
  cursor: pointer;
}

.backChev {
  fill: var(--fontColor);
  width: 14px;
  height: auto;
  transform: rotate(90deg);
}

@media only screen and (max-width: 1100px) {
  .msgGrid {
    display: grid;
    grid-template-columns: 40% 60%;
    gap: 0px;
    padding: 1rem;
    width: -webkit-fill-available;
    margin: 0 1rem 1rem 1rem;
  }
}

@media only screen and (max-width: 900px) {
  .msgGrid {
    display: grid;
    grid-template-columns: 100%;
    padding: 0;
    margin: 0;
    border-radius: 0;
  }

  #msgDetail {
    display: none;
  }

  #msgs {
    padding: 2rem;
    border-radius: 0;
  }

  #msgBack {
    display: block;
  }
}

@media only screen and (max-width: 480px) {
  #msgs {
    padding: 2rem 1rem;
  }
}

/* =========== GUIDE PAGE =============== */

.tabcontent {
  width: 100%;
}

.stepsBlock {
  border-left: 2px solid var(--secondaryColor);
  padding-left: 50px;
  position: relative;
  margin: 20px 0px;
  /* width: 100%; */
}

.stepsBlock > div {
  margin-bottom: 2.5rem;
}

.stepsBlock h6 {
  margin-bottom: 0.2rem;
}

.stepsBlock p {
  margin-bottom: 1rem;
  font-size: 12px;
}

.stepNum {
  position: absolute;
  left: -19px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: var(--secondaryColor);
  border-radius: 20px;
  width: 35px;
  height: 35px;
  font-size: 20px;
}

.linkP {
  cursor: pointer;
  color: var(--primaryColor);
}

.link:hover {
  color: var(--secondaryColor);
}

.link {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--primaryColor);
  fill: var(--primaryColor);
}

.link:hover {
  color: var(--secondaryColor);
  fill: var(--secondaryColor);
}

.link > svg {
  height: 30px;
  width: auto;
  margin-right: 5px;
}

/* =========== CONSENT PAGE =============== */

.optBlock {
  width: fit-content;
  text-align: center;
  margin: auto;
  margin-top: 20px;
}

.checkSVG {
  fill: grey;
}

.checkSVG > svg {
  height: 27px !important;
  width: auto;
}

.checkSVG:hover {
  fill: var(--primaryColor);
}

.arrowDD {
  fill: var(--firstColor);
  width: 11px;
  height: auto;
}

.arrowDown {
  transform: rotateZ(90deg);
}

.formContainer {
  margin-bottom: 2rem;
}

.consentName {
  display: flex;
  padding: 12px 30px;
  align-items: center;
  cursor: pointer;
  background-color: var(--primaryColor);
  border-radius: 20px;
  margin-top: 20px;
}

.consentName > svg {
  margin-right: 10px;
  fill: white;
}

.consentName > h5 {
  margin: 0 !important;
  color: white;
}

.textContainer {
  padding: 30px;
  cursor: pointer;
  background-color: white;
  border-radius: 0px 0px 20px 20px;
  box-shadow: var(--shadow);
}

.textContainer ul,
.textContainer ol {
  margin-left: 20px;
}

.textContainer ul > li,
.textContainer ol > li {
  line-height: 21px;
}

.textContainer p {
  margin-bottom: 17px;
}

.borderR {
  border-radius: 20px 20px 0px 0px;
}

.oldBox {
  border: 2px solid #d3d3d3;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 0 15px lightgrey;
  padding: 10px;
}

.labelRow > .row {
  align-items: baseline;
  margin-bottom: 14px;
}

.labelRow > .row > label {
  width: 35%;
  font-weight: bold;
  line-height: 18px;
  font-size: 14px;
}

#assDets li {
  font-weight: 400;
}

#assDets span {
  font-weight: 700;
}

/* =========== ASSESSMENTS PAGE =============== */

.blockTabs {
  display: flex;
  margin: 0 4rem 2rem 4rem;
  border-radius: 10px;
  border: 3px solid var(--primaryColor);
  width: fit-content;
}

.blockTabs > div {
  padding: 0.5rem 1rem;
  border: none;
  border-right: 3px solid var(--primaryColor);
  color: var(--primaryColor);
  fill: var(--primaryColor);
  cursor: pointer;
  display: flex;
  align-items: center;
}

.blockTabs > div > svg {
  margin-right: 0.6rem;
  height: 27px;
  width: auto;
}

.blockTabs > div:last-child {
  border: none;
  border-right: none;
}

.blockActive {
  color: white !important;
  fill: white !important;
  background-color: var(--primaryColor);
}

/* =========== MY DEVELOPMENT PAGE =============== */

.graphics {
  height: 350px;
  width: auto;
  position: relative;
}

#bookImg {
  top: -65px;
}

#targetImg {
  top: -20px;
}

.finePrint {
  font-size: 11px;
  color: var(--mediumGrey);
}

@media only screen and (max-width: 910px) {
  .graphics {
    height: 350px;
    width: auto;
    position: relative;
  }

  #bookImg {
    top: 2rem;
  }
}

@media only screen and (max-width: 600px) {
  .graphics {
    height: 230px;
    width: auto;
    position: relative;
  }
}

@media only screen and (max-width: 400px) {
  .graphics {
    height: 180px;
    width: auto;
    position: relative;
  }
}

.cardCliclickable:hover {
  cursor: pointer;
  background-color: var(--trHover);
  color: var(--darkColour) !important;
}

.cardActive {
  background-color: var(--primaryColorOpacity);
  color: var(--darkColour) !important;
}

.cardActive h5 {
  font-weight: 700;
}

.ulResources {
  padding-left: 1.5rem;
  margin-top: 1.5rem;
  text-align: left;
}

.ratingStar {
  fill: var(--primaryColor);
  cursor: pointer;
  margin-right: 5px;
}

#resourceTable tr:hover {
  background-color: #fff;
}

/* =========== eFEEDBACK PAGE =============== */

.imgCards {
  display: flex;
  padding: 50px;
  gap: 20px;
  justify-content: center;
  margin: auto;
}

.imgCards .card {
  padding: unset;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.card button {
  margin: unset;
}

.card img {
  object-fit: cover;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 200px;
  min-height: 200px;
  width: 250px;
  max-width: 300px;
}

.cardInfo {
  padding: 2rem;
}

#myForm {
  position: relative;
  z-index: 2;
  display: flex;
}

#logo_speel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#duplicateBtn {
  position: absolute;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  bottom: 0;
  right: 0;
}

#duplicateBtn > svg {
  height: 25px;
  width: auto;
  margin-right: 10px;
}

#duplicateBtn:hover {
  color: var(--primaryColor);
  fill: var(--primaryColor);
  cursor: pointer;
}

/* ================== ASSIGN ASSESSMENT PAGE ======================= */

.whiteBox {
  background: #f8f8f8;
  box-shadow: 0px 2px 6px #00000041;
  border-radius: 10px;
  opacity: 1;
  padding: 3%;
  margin-top: 30px;
  width: 100%;
}

.grid-container-3col {
  display: grid;
  grid-template-columns: 25% 1fr 15%;
  grid-gap: 35px 40px;
  /* box-sizing: content-box; */
  width: 100%;
}

.grid-3col-aapage {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 1rem;
  align-items: center;
}

/* @media (max-width: 1620px) {
    .grid-container-3col-even {
        display: grid;
        grid-template-columns: 50% 50%;
    }
} */

/* ==============================================================
==================== RESPONSIVE ================================================================= */

@media only screen and (max-width: 1200px) {
  #logo_speel {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
    gap: 2rem;
    align-items: center;
  }

  #supportBlock {
    grid-column: 2/3;
    grid-row: 1;
    width: 100%;
    box-shadow: none;
    border-radius: 10px;
    z-index: 11;
    display: grid;
    grid-template-columns: auto;
    gap: 60px;
    padding: 3rem;
  }

  #left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
  }

  .grid-3col {
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr 1fr;
    gap: 1rem 3rem;
    align-items: center;
    justify-items: center;
    margin: 0 2rem;
  }
}

/* Small Desktop */
@media only screen and (max-width: 1000px) {
  #footerLogo {
    height: 100px;
  }

  #footer h6 {
    font-size: 12px;
    line-height: 14px;
  }

  #footer p {
    font-size: 10px;
    line-height: 21px;
  }

  #TCs p {
    font-size: 9px;
    line-height: 14px;
  }

  .smallCards {
    grid-template-columns: 1fr 1fr;
  }

  #intro {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    margin: 0px 50px 50px 50px;
    text-align: center;
  }

  #candiNav > div,
  #adminNav > div {
    margin: 0 1rem;
  }

  #supportBlock {
    padding: 2rem;
  }
}

@media only screen and (max-width: 910px) {
  input {
    /* width: 255px; */
    width: 100%;
  }

  select {
    /* width: 255px; */
    width: 100%;
  }
}

/* Tablet */
@media only screen and (max-width: 768px) {
  .grid-container-3col {
    grid-template-columns: 1fr;
  }

  /* login */

  #coverImg {
    display: none;
  }

  .loginContent {
    text-align: left;
    grid-column: 1 / span all;
    grid-row: 1;
    width: 90%;
    height: 100vh;
    background: #fff;
    box-shadow: none;
    z-index: 11;
    justify-content: center;
  }

  input {
    /* width: 255px; */
    width: 100%;
  }

  select {
    /* width: 255px; */
    width: 100%;
  }

  .bar {
    width: 100%;
  }

  #intLogoDesk {
    /* content: url('integrateLogo_white_Moboile.svg'); */
  }

  #supportBlock {
    grid-column: 2/3;
    grid-row: 1;
    width: 100%;
    box-shadow: none;
    border-radius: 10px;
    z-index: 11;
    display: grid;
    grid-template-columns: auto;
    gap: 60px;
    padding: 2rem;
  }

  #right {
    grid-template-columns: 1fr;
    gap: 5px 30px;
    margin-top: 0px;
  }

  /* Footer */
  #footer {
    grid-template-columns: auto auto auto;
    grid-template-rows: auto auto;
    gap: 10px;
  }

  #TCs p {
    text-align: center;
  }

  #TCs {
    grid-column: 1/5;
    grid-row: 3;
    align-self: end;
    justify-self: center;
    margin-top: 10px;
  }

  #TCs > a {
    text-align: center;
  }

  #myProfileDiv {
    grid-column: 2;
    grid-row: 1;
  }

  #maAssDiv {
    grid-column: 3;
    grid-row: 1;
  }

  #eFeedbackDiv {
    grid-column: 2;
    grid-row: 1;
    margin-top: 100px;
  }

  #myDevDiv {
    grid-column: 3;
    grid-row: 1;
    margin-top: 100px;
  }

  #homepageComputer {
    width: 400px;
    height: auto;
  }

  .cardSVG {
    width: 45px;
    height: auto;
  }

  .card {
    display: grid;
    align-content: stretch;
    grid-template-rows: 65px auto;
    justify-content: center;
  }

  /* cookies */

  #cookieBanner {
    width: 90%;
    bottom: 3%;
  }

  .cookieBtn {
    height: 50px;
  }

  #loginBtn,
  #forgotPassBtn,
  #ssoBtn {
    width: 321px;
  }
}

/* Small tablet*/
@media only screen and (max-width: 600px) {
  .loginHeading {
    width: 100%;
  }

  #loginDiv {
    width: 100%;
  }

  #loginBtn,
  #forgotPassBtn,
  #ssoBtn {
    width: 100%;
  }

  #logo_speel {
    flex-direction: column;
  }
}

/* Mobile */
@media only screen and (max-width: 480px) {
  .loginContent {
    width: 100%;
  }

  #supportBlock {
    gap: 50px;
  }

  .smallCards {
    grid-template-columns: 1fr;
  }

  #right {
    grid-template-columns: 1fr;
    gap: 5px 30px;
    margin-top: 0px;
  }

  input {
    width: 100%;
  }

  /* Footer */
  #footer {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    gap: 20px;
    justify-content: space-evenly;
    padding: 7% 10%;
  }

  #contact {
    grid-column: 1/3;
    grid-row: 3;
    align-self: center;
    justify-self: center;
    border-top: 2px solid #fff;
    padding-top: 20px;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    padding-top: 36px;
    margin-top: 10px;
  }

  #footer h6 {
    font-size: 15px;
    line-height: 16px;
  }

  #footer p {
    font-size: 13px;
    line-height: 25px;
  }

  #footerLogo {
    height: 105px;
    margin-right: 1rem;
  }

  #social {
    display: flex;
    margin-top: 10px;
  }

  #social > svg {
    fill: white;
    height: 21px;
    width: auto;
    margin-right: 21px;
  }

  #f_ContactUs {
    display: none;
  }

  #f_supportEmail,
  #f_supportNum {
    font-size: 15px !important;
    line-height: 28px !important;
  }

  #TCs p {
    font-size: 11px;
    text-align: center;
    line-height: 19px;
  }

  #TCs {
    grid-column: 1/3;
    grid-row: 4;
    align-self: end;
    justify-self: center;
    /* margin-top: 12px; */
    margin: 1rem;
  }

  #myProfileDiv {
    grid-column: 1;
    grid-row: 1;
  }

  #maAssDiv {
    grid-column: 2;
    grid-row: 1;
  }

  #eFeedbackDiv {
    grid-column: 1;
    grid-row: 2;
    margin-top: 0;
  }

  #myDevDiv {
    grid-column: 2;
    grid-row: 2;
    margin-top: 0;
  }

  #homepageComputer {
    width: 350px;
    height: auto;
  }

  /* Top Nav */

  #nav {
    /* position: absolute; */
    width: 100%;
  }

  #mainContent {
    top: 45px;
  }

  #logos {
    grid-column: 1/2;
    grid-row: 1;
  }

  #candiNav {
    flex-direction: column;
    grid-column: 1 / 5;
    padding: 1rem;
    z-index: 11;
    background-color: var(--primaryColor);
    width: 100%;
    display: none;
  }

  #bar2 {
    display: none;
  }

  #adminNav {
    flex-direction: column;
    display: none;
  }

  #homeBtn {
    display: block !important;
  }

  #candiNav > div,
  #adminNav > div {
    margin: 0.5rem;
  }

  /* cookies */

  #cookieBanner {
    grid-template-columns: auto;
    gap: 0px;
    width: 100%;
    box-shadow: none;
    padding: 1rem;
    border-radius: 0px;
    bottom: 0;
    text-align: center;
  }

  #cookieBanner > div {
    justify-content: center;
  }

  #cookieSVG {
    height: 22px;
    width: auto;
  }

  .cookieBtn {
    font-size: 14px;
    color: white;
    padding: 8px 30px;
    height: 40px;
    margin-top: 13px;
  }

  #cookieContainer {
    bottom: 0;
  }
}

/* ===== Record App ===== */
.RVli,
.HRli,
.HRli {
  /* display: flex; */
  position: relative;
  margin-left: 1rem;
  margin-bottom: 0.5rem;
}

.trash > svg {
  height: 1.1rem;
  width: auto;
  cursor: pointer;
  fill: var(--primaryColor);
  margin-left: 0.9rem;
  position: absolute;
  top: -2px;
}

td .trash > svg {
  position: unset;
  top: unset;
  margin-left: unset;
}

.trash > svg:hover {
  fill: var(--secondaryColor);
}

#assPackMsg,
#legalMsg {
  color: var(--errorColor);
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.5rem;
}

.inputNote {
  color: var(--errorColor);
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

/* ------------------Admin Reports ------------------------- */

.controlPanelGrid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
  width: 100%;
  margin-top: 1.2rem;
}

.box {
  background-color: var(--lightGrey);
  box-shadow: var(--shadow);
  border-radius: 12px;
  position: relative;
  width: 100%;
  padding: 2rem;
}

.boxInpt {
  border: 2px solid var(--mediumGrey);
  background-color: white;
}

.subBox {
  background-color: var(--primaryColorOpacity);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 2rem;
}

.subBox input,
.subBox select {
  border-color: var(--darkGrey);
}

/* .box input {
    border: 2px solid var(--mediumGrey);
    background-color: #fff;
} */

.noteBox {
  background-color: var(--primaryColorOpacity);
  color: var(--fontColor);
  padding: 1.5rem;
  border-radius: 20px;
  box-shadow: 0px 2px 6px #00000028;
}

@media only screen and (max-width: 1400px) {
  .controlPanelGrid {
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 900px) {
  .controlPanelGrid {
    grid-template-columns: 1fr;
  }
}

.tgglLabel {
  color: var(--fontColor);
}

.reportChart {
  width: minmax(auto, 1200px);
  height: auto;
  margin-bottom: 3rem;
}

.reportChart > canvas {
  position: relative;
}

/* Steps -> month slider */

.rating {
  margin: 1rem 0 3.5rem 0;
}

.rating > p:first-of-type {
  margin-bottom: 1rem;
}

.ratingSteps1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.ratingItem {
  background-color: var(--mediumGrey);
  border-radius: 30px;
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0;
}

.ratingLine {
  width: 100%;
  border: 4px solid var(--mediumGrey);
  background-color: var(--mediumGrey);
  margin-bottom: unset;
}

.selected {
  border-color: var(--secondaryColor);
  background-color: var(--secondaryColor);
}

.ratingActive {
  background-color: var(--secondaryColor);
  border-color: var(--secondaryColor);
}

.resultsNote {
  display: inline-flex;
  align-items: flex-start;
  margin-top: 40px;
  background-color: #d1d2d4;
  padding: 16px;
  border-radius: 7px;
}

.resultsNote > div {
  margin-right: 18px;
}

.resultsNote > div > p {
  font-size: 13px;
  line-height: 19px;
}

.ugFilters,
.legFilters {
  display: flex;
  align-items: center;
  align-content: center;
}
.filterTag {
  display: flex;
  align-items: center;
  align-content: center;
  margin-right: 0.6rem;
  background-color: var(--primaryColorOpacity);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  cursor: pointer;
}

.filterTag svg {
  margin-left: 0.5rem;
  width: 20px;
}

/* ---------------------- Application Detail ------------- */

.detailCard {
  background-color: var(--lightGrey);
  box-shadow: var(--shadow);
  border-radius: 12px;
  position: relative;
  width: 100%;
  padding: 2rem;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr 2fr 0.8fr 2fr;
  gap: 0.7rem 1rem;
}

.detailInfo {
  position: relative;
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 0.5rem;
}

@media only screen and (max-width: 1100px) {
  .detailCard {
    background-color: var(--lightGrey);
    box-shadow: var(--shadow);
    border-radius: 12px;
    position: relative;
    width: 100%;
    padding: 2rem;
    text-align: left;
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0.7rem;
  }

  .detailInfo {
    grid-template-columns: 1fr 2fr;
    gap: 0.5rem;
  }
}

.addInfoBox-2col {
  background-color: #f5f5f5;
  border-radius: 13px;
  padding: 2.5rem 2rem 1rem 2rem;
  width: 100%;
  margin: 1.5rem;
  position: relative;
  right: 34px;
  align-items: start;
}

.addInfoBox-2col label,
#newRequester label {
  color: black;
}

#APOquestions {
  background-color: #f5f5f5;
  border-radius: 13px;
  width: 100%;
  padding: 1.5rem;
  margin-top: 1.5rem;
  position: relative;
}

#APOquestions p {
  line-height: 17px;
  margin-bottom: 1rem;
}

/* ------------- Contact Form -------------------------- */
.CFgrid {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 1rem;
}

/* ------------- Add report -------------------------- */

.layoutReports {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 3rem;
  box-sizing: content-box;
  width: 100%;
}

@media only screen and (max-width: 1100px) {
  .layoutReports {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

.subBox1 {
  background: var(--lightGrey);
  color: var(--fontColor);
  grid-column: 2;
  padding: 43px;
  border-radius: 20px;
  box-shadow: 0px 2px 6px #00000028;
  margin-bottom: 2rem;
}

.resultsGrid {
  display: grid;
  grid-template-columns: 285px auto auto;
  grid-gap: 35px 30px;
  box-sizing: content-box;
  align-items: end;
}

.resultsGrid4Col {
  display: grid;
  grid-template-columns: 200px auto auto auto;
  grid-gap: 35px 30px;
  box-sizing: content-box;
  align-items: end;
}

.inputResults > div {
  display: inline-flex !important;
  align-items: center !important;
  margin-bottom: 8px;
}

.inputResults > div > h4 {
  margin-bottom: 0;
  font-size: 14px;
}

.inputResults > div > input:focus {
  outline: none !important;
  border-top: transparent !important;
  border-left: transparent !important;
  border-right: transparent !important;
}

.inputResults > div > .correct {
  border-color: #1d9f86 !important;
}

.inputResults > div > .incorrect {
  border-color: var(--errorColor) !important;
}

.inputResults > div > input {
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.3px;
  height: 25px;
  width: 60px;
  margin: 0;
  border: none;
  border-bottom: solid 2px !important;
  border-radius: 0px !important;
  border-color: var(--mediumGrey) !important;
  outline: none;
  min-width: unset;
  text-align: center;
  padding: 0px !important;
}

.dashInput > input {
  width: 32px !important;
}

.feilds > h4 {
  font-weight: normal;
  margin-bottom: 0px;
  margin-top: 14.5px;
  font-size: 14px;
}

.resultsNote {
  display: inline-flex;
  align-items: flex-start;
  margin-top: 40px;
  background-color: #d1d2d4;
  padding: 16px;
  border-radius: 7px;
}

.resultsNote > div {
  margin-right: 18px;
}

.resultsNote > div > p {
  font-size: 13px;
  line-height: 19px;
}

/* Steps */

.steps {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
}

.step {
  background-color: var(--mediumGrey);
  border-radius: 20px;
  width: 30px;
  height: 30px;
  color: white;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  padding: 4px;
}

.stepLine {
  width: 60px;
  border: 1.5px solid var(--mediumGrey);
  background-color: var(--mediumGrey);
  margin: unset;
}

.bgActive {
  background-color: var(--primaryColor);
}

.hrActive {
  border: 1.5px solid var(--primaryColor);
  background-color: var(--primaryColor);
}

/* List Table */

.listHead > tr > th {
  color: var(--fontColor);
  background-color: white;
  font-size: 14px !important;
  padding: 10px 5px !important;
}

.listBody {
  background-color: white;
}

.listBody > tr {
  border-bottom: none !important;
  padding-top: 10px;
  text-align: center;
}

.listBody > tr > td {
  text-align: center;
  padding: 8px !important;
}

a:hover,
td > img:hover {
  cursor: pointer;
}

a > svg:hover {
  fill: var(--primaryColor);
}

/* ---------------------viewApp page ------------------------ */
#scientistQs img {
  max-width: 20px;
  height: auto;
}

/* --------------------Drag & Drop --------------------------- */
.draggable {
  background-color: white;
  box-shadow: 0px 2px 6px #00000041;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  width: 800px;
  padding: 15px;
  margin: 10px 0px;
  width: 100%;
  max-width: 800px;
  align-items: center;
}

.draggable::after,
.draggable::before {
  margin: unset;
}

.draggable:hover {
  background-color: var(--primaryColorOpacity);
  cursor: pointer;
}

.draggable.dragging {
  background-color: var(--primaryColorOpacity);
  cursor: move;
}

.barLeft {
  display: inline-flex;
  margin-right: 20px;
}

.barRight {
  float: right;
}

.dragDots {
  margin-right: 1.5rem;
  fill: var(--primaryColor);
  color: var(--primaryColor);
  width: 5px;
  height: auto;
}

/*  drag & drop in a table */
.Tdraggable {
  background-color: transparent;
  box-shadow: unset;
  border-radius: unset;
  display: unset;
  justify-content: unset;
  width: unset;
  padding: unset;
  margin: unset;
  width: 100%;
  max-width: unset;
  align-items: unset;
}

.Tdraggable::after,
.Tdraggable::before {
  margin: unset;
}

.Tdraggable:hover {
  background-color: var(--trHover_);
  cursor: pointer;
}

.Tdraggable.dragging {
  background-color: var(--trHover_);
  cursor: move;
}

.TbarDots {
  object-fit: none;
  margin-left: 20px;
  margin-top: 16px;
}

/* =========================== LMS ====================== */

#lmsContainer {
  width: 100vw;
  height: 100vh;
  /* height: auto; */
  box-sizing: border-box;
  margin: 0;
  border: none;
  padding: 50px;
}

/* ---------Compare Users --------------------------- */

#compareBtn {
  float: left;
  margin-bottom: 12px;
  display: flex;
}

.compareGrid {
  display: grid;
  grid-template-columns: 150px auto;
  grid-gap: 35px 20px;
  box-sizing: content-box;
  width: 100%;
}

.hrCompare {
  margin: 0px 0px 25px 0px;
  border: 1px solid #cccccc;
}

.compareLabels {
  color: var(--primaryColor);
  margin-top: 309px;
}

.compareLabels > h4 {
  margin: 9.9px 0px;
  font-size: 14px;
}

.compareProfile {
  background: white;
  color: var(--fontColor);
  grid-column: 2;
  padding: 30px;
  border-radius: 20px;
  width: fit-content;
  box-shadow: 0px 2px 6px #00000041;
  min-width: 260px;
}

.compareProfileActive {
  background: var(--primaryColor);
  color: white;
  grid-column: 2;
  padding: 30px;
  border-radius: 20px;
  width: fit-content;
  min-width: 260px;
  box-shadow: 0px 2px 6px #00000041;
}

.profileDets > p {
  color: var(--fontColor);
  font-size: 11px;
  line-height: 18px;
  font-weight: lighter;
}

.profileDetsActive > p {
  color: white;
  font-size: 11px;
  line-height: 18px;
  font-weight: lighter;
}

.profileDets > h4 {
  font-size: 17px;
  margin-bottom: 7px;
}

.profileDetsActive > h4 {
  font-size: 17px;
  margin-bottom: 7px;
  color: white;
}

.compareProfileActive > .userinfo > label {
  color: white !important;
}

.userinfo > label {
  text-transform: none;
  font-weight: lighter;
}

.selectedCU {
  font-weight: bold;
}

.assNapp {
  margin: 20px 0px 26px 26px;
}

.compareli {
  font-size: 11px;
  list-style: none;
  font-weight: bold;
}

.compareli > li {
  line-height: 8px;
  font-size: 11px;
  color: var(--primaryColor);
}

.compareSubli {
  margin: 7px 0px 7px 15px;
  font-size: 11px;
}

.compareSubli > li {
  line-height: 13px;
  font-size: 11px;
  font-weight: normal;
}

#ppic_0,
#ppic_1,
#ppic_2 {
  position: absolute;
  width: 100px;
  top: -1px;
  left: -1px;
}

.ppContainer {
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  height: 100px;
  width: 100px;
  border: 2.5px solid var(--primaryColor);
  background-color: white;
  padding: 3px;
}

.imgTick {
  position: absolute;
  cursor: pointer;
  z-index: 1;
  margin-left: 65px;
  margin-top: 54px;
  width: 42px;
}

.fillWhite {
  fill: #fff;
}

.fillSecColour {
  fill: var(--secondaryColor);
}

.ppActive {
  border: 3px solid var(--secondaryColor);
}

/* ---Checkbox on green bg ---*/
.compareProfileActive > .userinfo > .checkContainer input ~ .tick {
  border: 2px solid white;
}

.compareProfileActive > .userinfo > .checkContainer input:checked ~ .tick {
  background-color: white;
}

.compareProfileActive > .userinfo > .checkContainer .tick:after {
  border: solid var(--primaryColor);
  border-width: 0 2px 2px 0;
}

/* ---Checkbox not valid ---*/
.compareProfile > .userinfo > .checkContainer input:checked ~ .na {
  background-color: #d3d3d3;
}

.compareProfile > .userinfo > .checkContainer .na:after {
  border: solid #d3d3d3;
  border-width: 0 2px 2px 0;
}

.compareProfileActive > .userinfo > .checkContainer input ~ .na {
  border: 2px solid #8d8d8d;
}

.compareProfileActive > .userinfo > .checkContainer input:checked ~ .na {
  background-color: #d3d3d3;
}

.compareProfileActive > .userinfo > .checkContainer .na:after {
  border: solid #d3d3d3;
  border-width: 0 2px 2px 0;
}

input ~ .na {
  border: 2px solid #8d8d8d;
  background-color: #d3d3d3;
}

input:checked ~ .na {
  background-color: #d3d3d3;
  border: 2px solid #8d8d8d;
}

.na:after {
  border: solid #d3d3d3;
  border-width: 0 2px 2px 0;
}

.checkContainer:hover input ~ .na {
  background-color: #d3d3d3;
  cursor: none;
}

.checkContainer .na:after {
  border: solid #d3d3d3;
  border-width: 0 2px 2px 0;
}

.fyi {
  background-color: #d1d2d4;
  padding: 16px;
  max-width: 350px;
  border-radius: 7px;
}

.fyi > p {
  font-size: 12px;
  line-height: 20px;
}

#eFeedbackLms {
  margin-top: 4rem;
  min-height: 65vh;
}

#allocatedCourses {

}

.jvrLmsCourseContainer {
  margin: 0 4rem;
}

.no-lms-data-error {
  margin: 0 4rem;
}

.vimeoContainer {
  overflow: hidden;
  /* 16:9 aspect ratio */
  padding-top: 56.25%;
  position: relative;
  margin: 8rem 0;
}

.vimeoContainer > iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.courseHeaderContainer {
  display: flex;
  justify-content: space-between;
}

.courseHeaderContainer > svg {
  width: 32px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;EACzB,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;;EAE/B,UAAU;EACV,sCAAsC;EACtC,mCAAmC;;EAEnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,qEAAqE;;AAErE;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;;IAEE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA,WAAW;AACX;EACE;;IAEE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;;IAEE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;EAChD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mCAAmC;;EAEnC,aAAa;AACf;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;;gBAGc;EACd,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;IAC5B,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;AAC5B;;AAEA;;;;GAIG;;AAEH,kDAAkD;AAClD;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;;;EAGE,UAAU;EACV,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,UAAU;EACV,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,UAAU;EACV,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;;EAEE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA,eAAe;AACf,aAAa;AACb,wCAAwC;AACxC;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,qCAAqC;AACvC;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,WAAW;;AAEX,2CAA2C;AAC3C;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;;AAEX,eAAe;;AAEf;EACE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,qCAAqC;;AAErC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;;gDAEgD;;AAEhD,8BAA8B;;AAE9B;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yDAAyD;EACzD,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,qDAAqD;;AAErD;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qCAAqC;;AAErC,sDAAsD;;AAEtD;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;;EAEX,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;;EAEX,yBAAyB;EACzB,sBAAsB;;EAEtB;;aAEW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,qCAAqC;;AAErC;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX;kBACgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,+CAA+C;EAC/C,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA,2CAA2C;;AAE3C;EACE,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,UAAU;EACV,uCAAuC;EACvC,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;AACf;;AAEA,oDAAoD;AACpD,oDAAoD;AACpD;EACE,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iCAAiC;;EAEjC,wBAAwB;EACxB,6CAA6C;EAC7C,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sDAAsD;;AAEtD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,aAAa;EACb,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA,iDAAiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH,yCAAyC;AACzC;;EAEE,2BAA2B;EAC3B,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,QAAQ;AACV;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,iBAAiB;;IAEjB,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;;EAEE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,0DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6CAA6C;;AAE7C;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,kCAAkC;EAClC,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,WAAW;;EAEX,+BAA+B;AACjC;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,aAAa;IACb,6BAA6B;IAC7B,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,2CAA2C;;AAE3C;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA,6CAA6C;;AAE7C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,2CAA2C;EAC3C,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;;AAEA,sEAAsE;;AAEtE;EACE,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;mGACmG;;AAEnG;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,0BAA0B;EAC5B;;EAEA,UAAU;;EAEV;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,qCAAqC;IACrC,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA,YAAY;;EAEZ;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,YAAY;EACd;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA,WAAW;EACX;IACE,8BAA8B;IAC9B,uCAAuC;IACvC,SAAS;IACT,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA,YAAY;;EAEZ;IACE,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,qCAAqC;IACrC,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,cAAc;EAChB;;EAEA,YAAY;;EAEZ;IACE,2BAA2B;IAC3B,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,2BAA2B;AAC3B;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;GAGG;;AAEH;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,4DAA4D;;AAE5D;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE;IACE,kCAAkC;IAClC,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;AACX;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,eAAe;;AAEf;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,YAAY;AACd;;AAEA,gEAAgE;AAChE;EACE,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA,uDAAuD;;AAEvD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;AAEA;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[":root {\n  /* Colours */\n  --primaryColor: #1d9f86;\n  --primaryColorOpacity: #1d9f8534;\n  --secondaryColor: #b6bb34;\n  --secondaryColorOpacity: #b6bb3444;\n  --secondaryColorLight: #dee0b9;\n  --thirdColor: #215257;\n  --fourthColour: #739092;\n  --darkColour: #132530;\n  --lightGrey: #e8e8e8;\n  /* #eaeaea; */\n  --mediumGrey: #cccccc;\n  --darkGrey: #a3a3a3;\n  --fontColor: #000000;\n  --fontLightColor: #fff;\n  --errorColor: #db0000;\n  --errorColorLight: #eec4c4;\n  --errorHoverColor: #b91313;\n  --warningColor: #ff9616;\n  --warningColorLight: #ffe7c5;\n  --warningHoverColor: #f67b00;\n  --trHover: #e8e9c8;\n  --shadow: 0px 2px 6px #00000041;\n\n  /* Fonts */\n  --headingFont: 'Open Sans', sans-serif;\n  --copyFont: 'Open Sans', sans-serif;\n\n  /* Font sizes */\n  --copySize: 14px;\n  --h1Size: 28px;\n  --h3Size: 22px;\n  --h5Size: 16px;\n  --letterSpacingHeading1: 0.5px;\n  --letterSpacingHeading2: 0.2px;\n  --letterSpacingCopy: 0.3px;\n}\n\n/* ---------------------------------------------------------------- */\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\ndiv {\n  font-family: var(--copyFont);\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.3px;\n}\n\n.body {\n  display: grid;\n  grid-template-columns: 100vw;\n  /* 1fr */\n  min-height: 100vh;\n  align-content: space-between;\n  overflow: hidden;\n}\n\nh1 {\n  margin: unset;\n  font-family: var(--headingFont);\n  font-size: var(--h1Size);\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: var(--primaryColor);\n  letter-spacing: var(--letterSpacingHeading1);\n  line-height: 35px;\n  width: fit-content;\n}\n\nh2 {\n  margin: unset;\n  font-family: var(--headingFont);\n  font-size: var(--h1Size);\n  color: var(--secondaryColor);\n  margin-bottom: 10px;\n  letter-spacing: var(--letterSpacingHeading1);\n  line-height: 35px;\n}\n\nh3 {\n  margin: unset;\n  font-family: var(--headingFont);\n  font-size: var(--h3Size);\n  font-weight: 600;\n  color: var(--primaryColor);\n  margin-top: 0px !important;\n  letter-spacing: var(--letterSpacingHeading2);\n  margin-bottom: 1rem;\n}\n\nh4 {\n  margin: unset;\n  font-family: var(--headingFont);\n  font-size: var(--h3Size);\n  font-weight: 600;\n  color: var(--fontColor);\n  margin-bottom: 1rem;\n  letter-spacing: var(--letterSpacingHeading2);\n}\n\nh5 {\n  margin: unset;\n  font-family: var(--headingFont);\n  font-size: var(--h5Size);\n  color: var(--primaryColor);\n  margin-bottom: 0.8rem;\n  letter-spacing: var(--letterSpacingHeading2);\n  line-height: 26px;\n  font-weight: 600;\n}\n\nh6 {\n  margin: unset;\n  font-family: var(--headingFont);\n  font-size: var(--h5Size);\n  /* color: var(--secondaryColor); */\n  margin-bottom: 0.8rem;\n  letter-spacing: var(--letterSpacingHeading2);\n  line-height: 26px;\n  font-weight: 600;\n}\n\np {\n  color: var(--copyColor);\n  font-family: var(--copyFont);\n  font-size: var(--copySize);\n  letter-spacing: var(--letterSpacingCopy);\n  line-height: 22px;\n  font-weight: 400;\n}\n\n/* Tablet */\n@media only screen and (max-width: 768px) {\n  h1,\n  h2 {\n    font-size: 26px;\n    font-weight: bold;\n    margin-bottom: 18px;\n    letter-spacing: var(--letterSpacingHeading1);\n    line-height: 35px;\n  }\n\n  h3,\n  h4 {\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    letter-spacing: var(--letterSpacingHeading2);\n  }\n\n  h5,\n  h6 {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  p {\n    font-size: 12px;\n    line-height: 21px;\n  }\n\n  div {\n    font-family: var(--copyFont);\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 21px;\n    letter-spacing: 0.3px;\n  }\n}\n\n/* Mobile */\n@media only screen and (max-width: 480px) {\n  h1,\n  h2 {\n    font-size: 26px;\n    font-weight: bold;\n    margin-bottom: 18px;\n    letter-spacing: var(--letterSpacingHeading1);\n    line-height: 35px;\n  }\n\n  h3,\n  h4 {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    letter-spacing: var(--letterSpacingHeading2);\n  }\n\n  h5,\n  h6 {\n    font-size: 12px;\n    margin-bottom: 8px;\n    line-height: 22px;\n  }\n\n  p {\n    font-size: 10px;\n    line-height: 18px;\n  }\n\n  div {\n    font-family: var(--copyFont);\n    font-weight: 600;\n    font-size: 10px;\n    line-height: 18px;\n    letter-spacing: 0.3px;\n  }\n}\n\n.instructionP {\n  color: var(--darkGrey);\n}\n\n.greyBG {\n  color: #7b7b7b;\n  padding: 3rem;\n  width: 100vw;\n}\n\n.instructionP {\n  color: #7b7b7b;\n}\n\nhr {\n  border: 1.5px solid var(--lightGrey);\n  background-color: var(--lightGrey);\n  margin: 0px 0px 30px 0px;\n  width: 100%;\n}\n\n.greyBG hr {\n  border: 1.5px solid var(--mediumGrey);\n  background-color: var(--mediumGrey);\n  margin: 20px 0px;\n  width: 100%;\n}\n\n.formHR {\n  border: 1.5px solid var(--primaryColor) !important;\n  background-color: var(--primaryColor) !important;\n  margin: 2rem 0px;\n  width: 100%;\n}\n\n.vr {\n  border-left: 2px solid #fff;\n  height: 20px;\n  margin: 0 15px;\n}\n\nul {\n  padding: 0.5rem 0;\n}\n\nol {\n  padding: 0.5rem 0;\n}\n\n.hide {\n  display: none !important;\n}\n\n/* Loader */\n/* #loader {\n    display: none;\n    position: fixed;\n    left: 43%;\n    top: 45%;\n    z-index: 10;\n    border: 16px solid var(--lightGrey);\n    border-radius: 50%;\n    border-top: 16px solid var(--primaryColor);\n    width: 120px;\n    height: 120px;\n    -webkit-animation: spin 2s linear infinite;\n    animation: spin 2s linear infinite;\n}\n\n#loaderOverlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.61);\n    z-index: 9;\n\n} */\n\n#borderQA {\n  pointer-events: none;\n  border: 0.5rem solid red;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  z-index: 101;\n}\n\n#loader {\n  position: fixed;\n  top: 0;\n  z-index: 101;\n  background-color: rgba(0, 0, 0, 0.68);\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  /* justify-content: flex-start; */\n  align-items: center;\n  flex-direction: column;\n  gap: 1rem;\n  color: white;\n}\n\n#spinner {\n  position: fixed;\n  /* left: 43%; */\n  /* top: 45%; */\n  z-index: 10;\n  border: 16px solid var(--lightGrey);\n  border-radius: 50%;\n  border-top: 16px solid var(--primaryColor);\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n#loaderMsg {\n  position: absolute;\n  margin-top: 10rem;\n}\n\n#loader1 {\n  display: block;\n  position: absolute;\n  left: 43%;\n  top: 45%;\n  z-index: 12;\n  border: 16px solid var(--lightGrey);\n  border-radius: 50%;\n  border-top: 16px solid var(--primaryColor);\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.smallBox {\n  background-color: var(--primaryColorOpacity);\n  border-radius: 10px;\n  padding: 2rem;\n}\n\n.smallBox > input {\n  border-bottom: 2px solid var(--darkGrey);\n}\n\n.btn {\n  font-family: var(--copyFont);\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: var(--letterSpacingCopy);\n  color: var(--fontLightColor);\n  fill: var(--fontLightColor);\n  padding: 12px 25px;\n  background-color: var(--primaryColor);\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  text-transform: none;\n  min-width: 170px;\n  justify-content: center;\n  align-items: center;\n}\n\n.btn:hover {\n  background-color: var(--secondaryColor);\n  border: none;\n  outline: none;\n}\n\n.btnCancel {\n  font-family: var(--copyFont);\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: var(--letterSpacingCopy);\n  color: var(--primaryColor);\n  fill: var(--primaryColor);\n  padding: 12px 25px;\n  background-color: transparent;\n  border: none;\n  border-radius: 11px;\n  border: solid 2px var(--primaryColor);\n  cursor: pointer;\n  text-transform: none;\n  min-width: 170px;\n  justify-content: center;\n  align-items: center;\n  margin: 0 1rem 1rem 1rem;\n}\n\n.btnCancel:hover {\n  cursor: pointer;\n  background-color: var(--mediumGrey);\n\n  outline: none;\n}\n\n#loginBtn:disabled,\n#forgotPassBtn:disabled {\n  background-color: var(--mediumGrey);\n}\n\n.btn:disabled {\n  background-color: var(--mediumGrey);\n  cursor: not-allowed;\n}\n\n.btnText {\n  transition: all 0.2s;\n}\n\n/* change btn text visibility */\n.invisible {\n  visibility: hidden;\n  opacity: 0;\n}\n\n/* btn onclick loading animation  */\n.btnLoading::after {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  /* top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0; */\n  margin: auto;\n  border: 4px solid transparent;\n  border-top-color: var(--fontLightColor);\n  border-radius: 50%;\n  animation: btnLoading-spinner 1s ease infinite;\n}\n\n@keyframes btnLoading-spinner {\n  from {\n    transform: rotate(0turn);\n  }\n\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n.btn2 {\n  font-family: var(--copyFont);\n  font-size: 15px;\n  color: white;\n  padding: 14px 30px;\n  background-color: var(--secondaryColor);\n  border: none;\n  border-radius: 11px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-right: 10px !important;\n  cursor: pointer;\n  text-transform: none;\n}\n\n.btn2:hover {\n  background-color: var(--thirdColor);\n  border: none;\n  outline: none;\n  color: var(--primaryColor);\n}\n\n.errBtn {\n  font-family: var(--copyFont);\n  font-size: 15px;\n  color: white;\n  padding: 14px 42px;\n  background-color: var(--errorColor);\n  border: none;\n  border-radius: 21px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: flex;\n  margin: auto;\n  cursor: pointer;\n  justify-content: center;\n  text-transform: none;\n}\n\n.errBtn:hover {\n  background-color: var(--errorHoverColor);\n}\n\n.clearBtn {\n  position: relative;\n  border: none;\n  border-radius: 5px;\n  background-color: transparent;\n  cursor: pointer;\n  color: rgb(82, 82, 82);\n  box-shadow: none;\n  min-width: 100px;\n}\n\n.clearBtn:hover {\n  font-weight: bold;\n}\n\n.clearBtn svg {\n  fill: rgb(82, 82, 82);\n  height: 11px;\n}\n\n.subBtn {\n  border: none;\n  border-radius: 5px;\n  background-color: var(--secondaryColor);\n  cursor: pointer;\n  color: white;\n  padding: 10px 20px;\n  box-shadow: none;\n  text-align: center;\n  width: auto;\n}\n\n.subBtn:hover {\n  color: white;\n  background-color: var(--secondaryColor);\n  box-shadow: none;\n  border: none;\n}\n\n.btnEndGrid {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  /* margin-top: 30px; */\n}\n\n.btnCenterGrid {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: center;\n}\n\n.btnCenterGrid > button:first-child {\n  margin: 0 1rem 1rem 0;\n}\n\n.btnCenterGrid > button:last-child {\n  margin: 0 0 1rem 0;\n}\n\n.btnSVG {\n  font-family: var(--copyFont);\n  font-size: 13px;\n  font-weight: 400;\n  letter-spacing: var(--letterSpacingCopy);\n  color: var(--fontLightColor);\n  fill: var(--fontLightColor);\n  padding: 11px 20px;\n  background-color: var(--thirdColor);\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  min-width: 150px;\n  justify-content: center;\n  align-items: center;\n  margin-right: 1rem;\n}\n\n.btnSVG:hover {\n  background-color: var(--secondaryColor);\n}\n\n.btnSVG > svg {\n  height: 17px;\n  width: auto;\n  margin-right: 5px;\n}\n\n.actionBtn {\n  background-color: var(--lightGrey);\n  color: var(--primaryColor);\n  fill: var(--fontLightColor);\n  font-family: var(--copyFont);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: var(--letterSpacingCopy);\n  width: fit-content;\n  padding-right: 1rem;\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  min-width: 150px;\n  height: 45px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-right: 1rem;\n}\n\n.actionBtn > span:first-child {\n  background-color: var(--primaryColor);\n  border-radius: 11px 0 0 11px;\n  margin-right: 1rem;\n  height: inherit;\n  display: flex;\n  align-items: center;\n  padding: 0px 0.8rem;\n}\n\n.actionBtn:hover {\n  background-color: var(--mediumGrey);\n}\n\n#reactivateBtn {\n  margin-bottom: 0;\n  margin-left: 1rem;\n}\n\n.linkOpenTab {\n  color: var(--primaryColor);\n  text-decoration: underline;\n  cursor: pointer;\n  display: inline-flex;\n  margin-left: 0.5rem;\n}\n\n.linkOpenTab svg {\n  width: 20px;\n  height: auto;\n  /* padding-top: 5px; */\n  margin-left: 0.2rem;\n}\n\n.greyBG {\n  background-color: var(--lightGrey);\n}\n\n.width100 {\n  width: 100%;\n}\n\n.responsivePadding {\n  display: grid;\n  grid-template-columns: minmax(auto, 1200px);\n  justify-content: center;\n  justify-items: center;\n}\n\n.responsiveHeading {\n  display: grid;\n  grid-template-columns: minmax(auto, 1200px);\n  justify-content: center;\n  justify-items: start;\n  padding: 2rem 0 0 0;\n  margin: 1rem 4rem;\n}\n\n.inlineTableHeading {\n  margin: 1rem 4rem;\n  padding: 2rem 0 0 0;\n}\n\n.responsiveHeadingTable {\n  display: grid;\n  /* grid-template-columns: minmax(auto, 1200px); */\n  margin: 0 4rem;\n  justify-content: start;\n  justify-items: start;\n  padding: 2rem 0 0 0;\n}\n\n@media only screen and (max-width: 1300px) {\n  .responsivePadding {\n    grid-template-columns: 1fr;\n    padding: 0 3rem;\n  }\n\n  .responsiveHeading {\n    grid-template-columns: 1fr;\n    padding: 2rem 3rem 0 3rem;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .responsivePadding {\n    grid-template-columns: 1fr;\n    padding: 0 2rem;\n  }\n\n  .responsiveHeading {\n    grid-template-columns: 1fr;\n    padding: 1rem 2rem 0 2rem;\n  }\n}\n\n.grid-1col-input {\n  display: grid;\n  grid-template-columns: minmax(auto, 800px);\n  justify-items: start;\n  margin: 0 2rem;\n}\n\n.grid-1col {\n  display: grid;\n  grid-template-columns: minmax(auto, 1200px);\n  justify-items: start;\n}\n\n.grid-2col {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n  justify-items: center;\n  margin: 0 2rem;\n}\n\n.grid-3col {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n  justify-items: center;\n  margin: 0 2rem;\n}\n\n.grid-2col-input {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: 320px 320px;\n  gap: 10px 160px;\n}\n\n@media only screen and (max-width: 910px) {\n  .grid-2col-input {\n    display: grid;\n    justify-content: center;\n    grid-template-columns: 1fr;\n    gap: 10px 0px;\n  }\n\n  .grid-2col {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n    margin: 0 2rem;\n  }\n\n  .grid-1col {\n    margin: 0 2rem;\n  }\n\n  .group {\n    width: 100%;\n  }\n\n  .row > .group {\n    width: 100% !important;\n    margin: 0 2rem 1rem 0 !important;\n  }\n\n  .row {\n    flex-direction: column !important;\n  }\n\n  .row .marginLeft {\n    margin-left: unset;\n  }\n}\n\n.grid-2col-input-custard {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: 320px 320px;\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n@media only screen and (max-width: 1155px) {\n  .grid-2col-input-custard {\n    grid-template-columns: 320px;\n    gap: 2rem;\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n  flex-wrap: wrap;\n  /* margin-bottom: 20px; */\n}\n\n.float {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: left;\n}\n\n.floatItem {\n  margin-right: 35px;\n  margin-bottom: 20px;\n}\n\n.marginTop {\n  margin-top: 1.5rem;\n}\n\n.marginBottom {\n  margin-bottom: 1.5rem;\n}\n\n.sectionGap {\n  margin-bottom: 3rem;\n}\n\n.marginLeft {\n  margin-left: 3rem;\n}\n\n.marginRight {\n  margin-right: 3rem;\n}\n\n/*================================ INPUT====================== */\n.group {\n  position: relative;\n  margin-bottom: 34px;\n  width: 100%;\n}\n\n.row > .group {\n  width: unset;\n  margin: 0 2rem 3rem 0;\n}\n\n.inptAddBtnDiv {\n  display: flex;\n  align-items: flex-start;\n}\n\n.inptAddBtnDiv button {\n  margin-left: 10px;\n  padding: 6px 10px;\n}\n\n.inptAddBtnDiv img {\n  height: 17px;\n  margin-top: 3px;\n}\n\ninput {\n  font-family: var(--copyFont);\n  font-size: 14px;\n  padding: 7px 7px 7px 5px;\n  letter-spacing: var(--letterSpacingCopy);\n  display: block;\n  width: 310px;\n  border: none;\n  border-bottom: 2px solid var(--mediumGrey);\n  margin-bottom: 8px;\n  background-color: #0000;\n  /* padding-left: 38px; */\n}\n\nselect {\n  font-family: var(--copyFont);\n  font-size: 14px;\n  padding: 7px 7px 7px 5px;\n  letter-spacing: var(--letterSpacingCopy);\n  display: block;\n  width: 310px;\n  border: none;\n  border-bottom: 2px solid var(--mediumGrey);\n  margin-bottom: 8px;\n  background-color: transparent;\n}\n\nselect[multiple] {\n  border: 2px solid var(--mediumGrey);\n  background-color: white;\n  margin-top: 1rem;\n}\n\nselect[multiple]:focus {\n  border: 2px solid var(--primaryColor);\n}\n\noption {\n  color: var(--darkColour);\n  /* background-color: white; */\n}\n\ntextarea {\n  font-family: var(--copyFont);\n  font-size: 14px;\n  padding: 7px 7px 7px 5px;\n  letter-spacing: var(--letterSpacingCopy);\n  width: 100%;\n  height: 120px;\n  border: 2px solid var(--mediumGrey);\n  padding: 10px;\n  font: var(--copyFont);\n  letter-spacing: var(--letterSpacingCopy);\n  font-weight: 400;\n  margin-top: 10px;\n}\n\ninput:focus {\n  outline: none;\n}\n\nselect:focus {\n  outline: none;\n  border-bottom: 2px solid var(--primaryColor);\n}\n\nselect:hover {\n  cursor: pointer;\n}\n\ntextarea:focus {\n  outline: none;\n  border: 2px solid var(--primaryColor);\n}\n\ninput[type='password'] {\n  letter-spacing: 1.1px;\n}\n\ninput[type='radio'] {\n  cursor: pointer;\n  width: fit-content;\n}\n\ninput[type='file'] {\n  display: none;\n}\n\n.borderInput {\n  border: 2px solid var(--mediumGrey);\n  border-radius: 7px;\n  /* height: 40px; */\n}\n\na {\n  /* margin-top: 5px; */\n  color: var(--fontColor);\n  text-decoration: none;\n}\n\na:hover {\n  cursor: pointer;\n}\n\n/* Chrome, Safari, Edge, Opera - no arrows */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox - no arrows */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n/* i>img {\n    width: 24px;\n    top: 10px;\n    position: absolute;\n} */\n\n/* LABEL ======================================= */\nlabel {\n  font-family: var(--copyFont);\n  color: var(--darkGrey);\n  font-size: 14px;\n  font-weight: normal;\n  letter-spacing: var(--letterSpacingCopy);\n  /* pointer-events: none; */\n  left: 7px;\n  top: 7px;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n}\n\n.group > label {\n  position: absolute;\n}\n\n/* active state */\ninput:valid ~ label,\nselect:valid ~ label,\ntextarea:valid ~ label {\n  top: -15px;\n  font-size: 12px;\n  left: 0px;\n  color: var(--darkGrey);\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\nlabel {\n  top: -15px;\n  font-size: 12px;\n  left: 0px;\n  color: var(--darkGrey);\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\ninput:invalid ~ label,\nselect:invalid ~ label,\ntextarea:invalid ~ label {\n  top: -15px;\n  font-size: 12px;\n  left: 0px;\n  color: var(--darkGrey);\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\ninput:focus ~ label,\nselect:focus ~ label,\ntextarea:focus ~ label {\n  top: -15px;\n  font-size: 12px;\n  left: 0px;\n  color: var(--primaryColor);\n  font-weight: 400;\n  letter-spacing: 0.5px;\n}\n\n.labelDescript {\n  font-size: 10px;\n  color: var(--darkColour);\n  text-transform: none;\n  font-weight: 500;\n  margin-bottom: 10rem;\n  position: relative;\n}\n\n/* BOTTOM BARS ================================= */\n.bar {\n  position: relative;\n  display: block;\n  width: 310px;\n}\n\n.bar:before,\n.bar:after {\n  content: '';\n  height: 3px;\n  width: 0;\n  bottom: 7px;\n  position: absolute;\n  background: var(--primaryColor);\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n}\n\n.bar:before {\n  left: 50%;\n}\n\n.bar:after {\n  right: 50%;\n}\n\n/* active state */\ninput:focus ~ .bar:before,\ninput:focus ~ .bar:after {\n  width: 50%;\n}\n\n.primaryColor {\n  color: var(--primaryColor);\n  fill: var(--primaryColor);\n}\n\n.errorColor {\n  color: var(--errorColor);\n  fill: var(--errorColor);\n}\n\n.secondColor {\n  color: var(--secondaryColor);\n  fill: var(--primaryColor);\n}\n\n.warningColor {\n  color: var(--warningColor);\n  fill: var(--warningColor);\n}\n\n.bold {\n  font-weight: bold !important;\n}\n\n/* ANIMATIONS ================ */\n@-webkit-keyframes inputHighlighter {\n  from {\n    background: var(--secondColor);\n  }\n\n  to {\n    width: 0;\n    background: transparent;\n  }\n}\n\n@-moz-keyframes inputHighlighter {\n  from {\n    background: var(--secondColor);\n  }\n\n  to {\n    width: 0;\n    background: transparent;\n  }\n}\n\n@keyframes inputHighlighter {\n  from {\n    background: var(--secondColor);\n  }\n\n  to {\n    width: 0;\n    background: transparent;\n  }\n}\n\n.inpFB {\n  position: absolute;\n  font-size: 10px;\n  color: var(--errorColor);\n  top: 36px;\n}\n\ninput[type='checkbox'] {\n  width: auto !important;\n  min-width: 18px;\n  height: 18px;\n  cursor: pointer;\n  z-index: 2;\n}\n\ninput[type='radio'] {\n  width: auto !important;\n}\n\ninput[type='search']::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  cursor: pointer;\n  height: 18px;\n  width: 18px;\n  /* content: url(../assets/img/icons/clearSearch.svg); */\n}\n\n.newEntry {\n  /* border-color: var(--secondaryColor) !important; */\n  margin-top: 10px;\n}\n\n/* Upload button  - 2 part*/\n.uploadbtn {\n  border: none;\n  border-radius: 5px;\n  background-color: #dedede;\n  cursor: pointer;\n  font-size: 12px !important;\n  color: var(--primaryColor) !important;\n  margin: 5px 5px;\n  padding: 10px 0px 10px 20px;\n  height: 40px;\n  width: fit-content;\n}\n\n.uploadbtn:hover {\n  background-color: #cacaca;\n}\n\n.uploadAdd {\n  background-color: var(--primaryColor);\n  font-size: 25px;\n  color: white;\n  margin-left: 10px;\n  border-radius: 0px 5px 5px 0px;\n  padding: 3px 7px 0px 7px;\n  margin-top: 5px;\n  vertical-align: middle;\n  align-items: center;\n  height: 40px;\n}\n\n/* ---------- */\n/* checkbox */\n/* Customize the label (the container) */\n.checkContainer {\n  all: unset;\n  display: block;\n  position: relative;\n  padding-left: 30px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.checkContainer input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\nlabel.checkContainer {\n  line-height: 17px;\n  font-size: 14px;\n  width: auto;\n  cursor: pointer;\n}\n\nlabel.checkContainer p {\n  /* font-weight: 300; */\n  font-size: 12px;\n}\n\n/* Create a custom checkbox */\n.tick {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: transparent;\n  border: 2px solid var(--primaryColor);\n}\n\n/* On mouse-over, add a grey background color */\n.checkContainer:hover input ~ .tick {\n  background-color: #e6e6e6;\n}\n\n/* When the checkbox is checked, add a blue background */\n.checkContainer input:checked ~ .tick {\n  background-color: var(--primaryColor);\n}\n\n/* Create the tick/indicator (hidden when not checked) */\n.tick:after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n\n/* Show the tick when checked */\n.checkContainer input:checked ~ .tick:after {\n  display: block;\n}\n\n/* Style the tick/indicator */\n.checkContainer .tick:after {\n  left: 4px;\n  top: -1px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.addInfoBox {\n  background-color: #f5f5f5;\n  border-radius: 13px;\n  padding: 2.5rem 2rem 1px 2rem;\n  width: min-content;\n  margin-top: 1.5rem;\n  position: relative;\n  right: 34px;\n}\n\n.addInfoBox > .group {\n  margin-bottom: 3.2rem;\n}\n\n.addInfoBox > .group:last-child {\n  margin-bottom: 2rem;\n}\n\n@media only screen and (max-width: 910px) {\n  .addInfoBox {\n    width: 100%;\n    position: relative;\n    right: unset;\n  }\n}\n\n.radioDescript {\n  top: -15px;\n  font-size: 12px;\n  left: 0px;\n  color: var(--darkGrey);\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  position: absolute;\n}\n\n.radioLabel {\n  position: unset !important;\n  display: flex;\n  margin-top: 1rem;\n  margin-right: 1rem;\n  align-items: center;\n  color: var(--fontColor);\n  cursor: pointer;\n  font-size: var(--copyFont);\n}\n\n.radioLabel > input[type='radio'] {\n  margin: 0 0.7rem 0 0;\n  accent-color: var(--primaryColor);\n}\n\n/* Toggle */\n\n/* The switch - the box around the slider */\n.switch {\n  all: unset;\n  position: relative;\n  display: inline-block;\n  margin: 0 1rem 0.5rem 0;\n  width: 50px;\n  height: 24px;\n  vertical-align: middle;\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The toggle */\n.toggle {\n  width: 50px;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.toggle.both {\n  background-color: var(--secondaryColor);\n}\n\n.tgglLable {\n  all: unset;\n  font-size: var(--copySize) !important;\n  color: var(--darkColour) !important;\n  position: relative;\n  top: -4px;\n}\n\n.toggle:before {\n  position: absolute;\n  content: '';\n  height: 16px;\n  width: 16px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .toggle {\n  background-color: var(--primaryColor);\n}\n\ninput:checked + .toggle:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.toggle.round {\n  border-radius: 34px;\n}\n\n.toggle.round:before {\n  border-radius: 50%;\n}\n\n/* ------ */\n\n/* Validation */\n\n.correct {\n  border-color: var(--primaryColor);\n}\n\n.incorrect {\n  border-color: var(--errorColor) !important;\n}\n\n.incorrect:focus {\n  border-color: var(--errorColor) !important;\n}\n\n/* =========== TABLE ============== */\n\ntable {\n  border-spacing: 1;\n  border-collapse: collapse;\n  overflow: hidden;\n  border: none;\n  white-space: normal !important;\n  margin: 0 4rem;\n  box-shadow: var(--shadow);\n  width: -webkit-fill-available;\n  border-radius: 11px;\n  background-color: white;\n  margin-bottom: 40px;\n}\n\ntable .btn {\n  width: fit-content;\n  min-width: unset;\n  font-size: 13px;\n}\n\nthead {\n  font-family: 'Open Sans', Arial, Helvetica, sans-serif;\n  letter-spacing: 0.2px;\n  border: none;\n  padding: 0px 20px !important;\n  height: 65px;\n}\n\nth {\n  font-size: 14px !important;\n  font-weight: 600;\n  border: none !important;\n  padding: 15px 5px !important;\n  font-family: var(--copyFont);\n  font-size: var(--h5Size);\n  color: white;\n  margin-bottom: 13px;\n  letter-spacing: var(--letterSpacingCopy);\n  background-color: var(--primaryColor);\n  text-align: center;\n  padding: 20px;\n  position: relative;\n}\n\ntd {\n  padding: 15px !important;\n  font-family: var(--copyFont);\n  font-size: 13px;\n  color: var(--copyColor);\n  letter-spacing: var(--letterSpacingCopy);\n  line-height: 20px;\n  padding: 20px;\n  font-weight: 400;\n  text-align: center;\n  width: auto;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* white-space: nowrap; */\n}\n\ntr {\n  border-bottom: 2px solid #e6e6e6 !important;\n  font-size: 13px !important;\n  background-color: #ffffff;\n  padding: 15px 15px !important;\n  text-transform: none !important;\n  white-space: normal !important;\n}\n\ntr:hover {\n  background-color: var(--trHover);\n}\n\n#mailBody > tr:hover {\n  background-color: none !important;\n}\n\ntable tr:last-of-type {\n  border-bottom: none;\n}\n\n#text table {\n  box-shadow: none !important;\n  margin: none !important;\n  background-color: none;\n}\n\n#text tr {\n  border-bottom: none !important;\n}\n\n#text td {\n  padding: 0.5rem !important;\n}\n\n.grid-1col table,\n.grid-1col-input table {\n  margin: 0 0 2rem 0;\n}\n\n.grid-2col table {\n  margin: 0 0 2rem 0;\n  width: 100%;\n}\n\n.grid-2col-input table {\n  margin: 0 0 3rem 0;\n  width: 100%;\n}\n\ntd > table {\n  background-color: white !important;\n  width: -webkit-fill-available !important;\n  margin-left: 0 !important;\n  margin: 0.5rem 1rem !important;\n}\n\n.center {\n  display: flex;\n  justify-content: center;\n}\n\n.middle {\n  display: flex;\n  align-items: center;\n}\n\n.tableIcon {\n  margin-left: 12px;\n}\n\ntable img,\ntable svg {\n  fill: var(--primaryColor);\n  max-height: auto;\n  width: 20px;\n}\n\n.tableImage {\n  width: auto;\n}\n\n.tableIcon svg {\n  fill: var(--primaryColor);\n  height: 23px;\n  width: auto;\n}\n\n.iconSize {\n  max-height: auto;\n  width: 20px;\n}\n/*     const svgElement = await svgStringParse(dragDotsSVG);\n    barLefts.forEach((bar) => {\n      bar.prepend(svgElement.cloneNode(true)); */\n\n/* ------Pagination -------- */\n\n#pagDiv {\n  text-align: center;\n  margin: 15px;\n}\n\n.pagNum {\n  font-size: 12px;\n  font-weight: normal;\n  color: #000000;\n  position: relative;\n  border: none;\n  border-radius: 5px;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 10px 20px;\n  box-shadow: none;\n}\n\n.pagNumActive {\n  font-size: 14px;\n  font-weight: bold;\n  position: relative;\n  border: none;\n  border-radius: 5px;\n  background-color: var(--secondaryColor);\n  cursor: pointer;\n  color: black;\n  padding: 10px 20px;\n  box-shadow: none;\n}\n\n.pagNum:hover {\n  font-weight: bold;\n}\n\n.pagArrow {\n  color: #000000;\n  position: relative;\n  border: none;\n  border-radius: 5px;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 10px 20px;\n  box-shadow: none;\n  font-size: 20px;\n}\n\n.pagArrow:hover {\n  color: var(--primaryColor);\n}\n\n/* ------Search Table --------------- */\n\n#searchSpace {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1rem 4rem;\n}\n\n#genSearch {\n  border: 2px solid var(--mediumGrey);\n  border-radius: 7px;\n  padding-left: 33px;\n  height: 40px;\n}\n\n#searchFilters {\n  width: auto;\n  height: 40px;\n  background-color: var(--primaryColor);\n  border-radius: 7px;\n  margin-left: 12px;\n  text-align: center;\n  top: -5px;\n  position: relative;\n  padding: 0px 18px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: white;\n  cursor: pointer;\n  margin-top: 5px;\n}\n\n#searchFilters > img {\n  width: 17px;\n  height: auto;\n  margin-left: 10px;\n  /* margin-top: 12px; */\n}\n\n#searchFilters:hover {\n  background-color: var(--secondaryColor);\n}\n\n.searchFiltersActive {\n  background-color: var(--secondaryColor) !important;\n}\n\n.searchBarIcon {\n  /* content: url(../assets/img/icons/magGlass_grey.svg); */\n  width: 14px;\n  fill: var(--darkColour);\n  position: absolute;\n  margin: 13px;\n}\n\n#trSearch {\n  background-color: #e8e8e8 !important;\n  /* #DEDEDE */\n  min-height: 65px;\n}\n\n#trSearch input {\n  min-width: 130px;\n  max-width: 180px;\n  margin: 10px;\n}\n\n#trSearch select {\n  min-width: 130px;\n  max-width: 175px;\n  margin: 10px;\n}\n\n.iconOff {\n  fill: #777777;\n  cursor: pointer;\n}\n\n.iconOn {\n  fill: var(--primaryColor);\n}\n\n.iconGrid {\n  display: grid;\n  grid-template-columns: auto auto;\n  align-items: center;\n  justify-items: center;\n  grid-gap: 8px;\n}\n\n#iconGrid svg {\n  cursor: pointer;\n}\n\n.clientLogoTable > img {\n  width: 60px;\n  height: auto;\n}\n\n.iconTable,\n.iconTable > svg {\n  width: 30px;\n  height: auto;\n  fill: var(--primaryColor);\n}\n\n/* ----------- Select Client ---------------------- */\n\n#selectC {\n  background-color: var(--primaryColorOpacity);\n  border-radius: 10px;\n  padding: 1.5rem 2rem;\n  margin-bottom: 30px;\n  margin-top: 2rem;\n  width: 100%;\n}\n\n#selectC select {\n  border-color: var(--darkGrey);\n}\n\n.selectCGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 0.5frs 1fr;\n  grid-gap: 15px 20px;\n  box-sizing: content-box;\n}\n\n#addToUserGroup {\n  grid-column: 4/5;\n  grid-row: 1;\n}\n\n#newGroupNameDiv {\n  grid-column: 1;\n  grid-row: 2;\n}\n\n#newGroupDescription {\n  grid-column: 2;\n  grid-row: 2;\n}\n\n#privateGroup {\n  grid-column: 3;\n  grid-row: 2;\n}\n\n.selectCHeading {\n  font-family: var(--headingFont);\n  font-size: 21px;\n  color: var(--primaryColor);\n  font-weight: normal;\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n}\n\n/* =========== LOGIN ============== */\n\n/*--------------- Login & Forgot Password------------*/\n\n.loginGrid {\n  position: absolute;\n  display: grid;\n  grid-template-columns: 10% 40% 40% 10%;\n  height: 100vh;\n  width: 100vw;\n  align-items: center;\n  justify-items: center;\n  z-index: 11;\n  overflow: hidden;\n}\n\n#coverImg {\n  min-height: 100vh;\n  width: auto;\n\n  background-position: center;\n  background-repeat: no-repeat;\n  -webkit-background-size: contain;\n  -moz-background-size: contain;\n  -o-background-size: contain;\n  background-size: contain;\n  z-index: 10;\n\n  grid-column: 1 / span all;\n  grid-row: 1 / span all;\n\n  /* position: fixed;\n    top: 0;\n    left: 0;*/\n}\n\n.loginContent {\n  grid-column: 3/4;\n  grid-row: 1;\n  width: 420px;\n  height: fit-content;\n  padding: 40px;\n  background: white;\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 10px;\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#loginLogos {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 15px;\n  justify-content: space-evenly;\n  padding: 0;\n  margin-bottom: 20px;\n}\n\n#loginLogos > img {\n  height: 200px;\n  width: 200px;\n  max-height: 90px;\n  max-width: 150px;\n}\n\n#loginDiv,\n#forgotPassDiv {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n}\n\n#loginDiv > h1,\n#forgotPassDiv > h1 {\n  margin-bottom: 6px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fontColor);\n  margin-bottom: 2px;\n}\n\n#loginDiv > p,\n#forgotPassDiv > p {\n  font-size: 12px;\n  margin-bottom: 22px;\n  /* color: var(--darkGrey); */\n  font-weight: 300;\n}\n\n.loginInputs {\n  width: 100%;\n}\n\n.loginInputs > .group > input {\n  width: 100%;\n}\n\n#langDivLogin {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n}\n\n#langDivLogin > select {\n  margin-bottom: unset;\n}\n\n#langDD {\n  right: unset;\n  width: fit-content;\n  border-bottom: none;\n  text-align: center;\n  padding: 0px 2px;\n}\n\n.langLoginSVG {\n  fill: black;\n  position: relative;\n}\n\n#langDiv {\n  display: flex;\n  align-items: center;\n}\n\n.langHomeSVG {\n  fill: white;\n  position: relative;\n  top: -3.5px;\n}\n\n.inputDarkGB {\n  color: white;\n  background-color: transparent;\n}\n\n#loginBtn,\n#forgotPassBtn {\n  background-color: var(--primaryColor);\n  text-align: center;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 100%;\n  max-width: unset;\n  margin: 5px 0px 5px 0px;\n  border-radius: 10px;\n}\n\n#ssoBtn {\n  background-color: var(--secondaryColor);\n  text-align: center;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 100%;\n  max-width: unset;\n  margin: 0.5rem 0;\n  border-radius: 10px;\n}\n\n#ssoBtnDiv {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.loginHelp {\n  color: var(--primaryColor);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0px;\n  margin-top: 4px;\n  cursor: pointer;\n  font-style: italic;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.loginHelp:hover {\n  font-weight: 600;\n}\n\n.loginHelp > span {\n  display: flex;\n  align-items: center;\n}\n\n#succSVG {\n  fill: var(--primaryColor);\n}\n\n.ctick {\n  fill: white;\n}\n\n.loginHelp > span > svg {\n  fill: var(--primaryColor);\n  height: 21px;\n  margin-left: 3px;\n  stroke-width: 0.4px;\n  stroke: var(--primaryColor);\n}\n\n.forgotPassword {\n  text-align: center;\n  color: var(--primaryColor) !important;\n  font-weight: normal;\n}\n\n.forgotPassword:hover {\n  font-weight: bold;\n}\n\n/* Login Support */\n\n.loginSupportGrid {\n  position: absolute;\n  display: grid;\n  grid-template-columns: 5% 90% 5%;\n  height: 100vh;\n  width: 100vw;\n  align-items: center;\n  justify-items: center;\n  z-index: 11;\n}\n\n#supportBlock {\n  grid-column: 2/3;\n  grid-row: 1;\n  width: 100%;\n  height: fit-content;\n  padding: 3rem;\n  background: white;\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 10px;\n  z-index: 11;\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 80px;\n}\n\n#left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-around;\n}\n\n.supportSpeel > h6 {\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.supportSpeel p {\n  font-size: 12px;\n  line-height: 19px;\n}\n\n#right {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: 1fr 1fr;\n  gap: 5px 30px;\n  align-content: center;\n  margin-top: 15px;\n}\n\n.attachedFile {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: var(--darkColour);\n}\n\n.attachedFile:hover {\n  fill: var(--secondaryColor);\n  color: var(--secondaryColor);\n}\n\n.attachedFile > svg {\n  margin-right: 5px;\n}\n\n.fileNamePreview {\n  display: flex;\n  align-items: center;\n  margin: 1rem 0;\n  padding: 0.5rem 1rem;\n  background-color: var(--lightGrey);\n  width: 100%;\n  justify-content: space-between;\n  font-weight: 400;\n}\n\n#backLogin {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: 2rem;\n}\n\n#backLogin:hover {\n  color: var(--secondaryColor);\n  fill: var(--secondaryColor);\n}\n\n#backLogin > svg {\n  margin-right: 5px;\n}\n\n#backLogin > h6 {\n  margin-bottom: 0;\n}\n\n#socialCU {\n  display: flex;\n  margin: 1rem 0;\n}\n\n#socialCU > svg,\n#socialCU > a > svg {\n  fill: var(--primaryColor);\n  height: 17px;\n  width: auto;\n  margin-right: 15px;\n}\n\n#socialCU > svg:hover,\n#socialCU > a > svg:hover {\n  fill: var(--thirdColor);\n  cursor: pointer;\n}\n\n/* =========== NAV ================ */\n\n#nav {\n  font-family: var(--copyFont);\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  color: #ffffff;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  grid-template-rows: auto auto auto;\n}\n\n#bar1 {\n  background-color: var(--darkColour);\n  grid-column: 1 / span all;\n  grid-row: 1;\n}\n\n#mobileNav {\n  display: none;\n}\n\n#langUserDeesktop {\n  grid-column: 1;\n  grid-column-end: span all;\n  grid-row: 1;\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 20px 5px 10px;\n  z-index: 1;\n}\n\n#userDD {\n  background-color: white;\n  box-shadow: var(--shadow);\n  color: var(--fontColor);\n  position: absolute;\n  border-radius: 5px;\n  right: 15px;\n  margin-top: 4px;\n  z-index: 2;\n}\n\n.userDDItem {\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n.userDDItem:first-child {\n  border-radius: 5px 5px 0 0;\n}\n\n.userDDItem:last-child {\n  border-radius: 0 0 5px 5px;\n}\n\n.userDDItem:hover {\n  cursor: pointer;\n  color: white;\n  background-color: var(--secondaryColor);\n  fill: white;\n}\n\n.chevron {\n  fill: white;\n  width: 13px;\n  height: auto;\n  margin-left: 5px;\n}\n\n.chevRotate {\n  transform: rotate(180deg);\n}\n\n#userDD > hr {\n  border: 1px solid var(--lightGrey);\n  background-color: var(--lightGrey);\n  /* margin: 10px 0px 10px 0px; */\n  margin: 0;\n}\n\n.userDDItem > svg {\n  margin-right: 10px;\n  max-width: 20px;\n  max-height: 20px;\n}\n\n#user {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  cursor: pointer;\n}\n\n#userImg {\n  border: 2px solid var(--secondaryColor);\n  height: 21px;\n  width: 21px;\n  border-radius: 10px;\n  margin-right: 5px;\n}\n\n#bar2 {\n  background-color: var(--primaryColor);\n  padding: 10px 30px;\n  min-height: 55px;\n  grid-column: 1 / span all;\n  grid-row: 2;\n}\n\n.bar2SVG {\n  height: 26px;\n  width: auto;\n  margin-right: 8px;\n}\n\n#logos {\n  grid-column: 1/2;\n  grid-row: 2;\n  z-index: 1;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  cursor: pointer;\n}\n\n#logos > img {\n  max-width: 125px;\n  height: 32px;\n  width: auto;\n}\n\n#candiNav {\n  grid-column: 2 / 5;\n  grid-row: 2;\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n}\n\n#adminNav {\n  background-color: var(--lightGrey);\n  grid-column: 1 / span all;\n  grid-row: 3;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 10px;\n  width: 100%;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  padding: 5px 30px;\n  min-height: 55px;\n  color: var(--darkColour);\n}\n\n#candiNav > div,\n#adminNav > div {\n  margin: 0 2rem;\n  display: flex;\n  align-items: center;\n  fill: white;\n  position: relative;\n}\n\n#adminNav > div {\n  padding-bottom: 7px;\n}\n\n#candiNav > div:hover {\n  fill: var(--darkColour);\n  color: var(--darkColour);\n  cursor: pointer;\n}\n\n#adminNav > div:hover {\n  fill: var(--primaryColor);\n  color: var(--primaryColor);\n  cursor: pointer;\n}\n\n.adminSVG {\n  fill: black;\n  /* height: auto;\n    width: 34px; */\n  margin-right: 8px;\n}\n\n/* ==== SUBMENUS === */\n#adminNav > div:hover .subMenu {\n  display: block;\n  transition-duration: 0.5s;\n}\n\n#adminNav > div:hover .subMenu:hover {\n  display: block;\n  fill: var(--primaryColor);\n  color: var(--primaryColor);\n}\n\n.subMenu {\n  position: absolute;\n  display: none;\n  /* fhjgek */\n  top: 16px;\n  background-color: #fff;\n  box-shadow: var(--shadow);\n  color: var(--fontColor);\n  border-radius: 5px;\n  margin-top: 4px;\n  z-index: 2;\n}\n\n.subItem {\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  color: var(--fontColor);\n}\n\n.subItem:hover {\n  background-color: var(--secondaryColor);\n  fill: var(--fontLightColor);\n  color: var(--fontLightColor);\n  border-radius: 5px;\n}\n\n.navActive {\n  font-weight: bold;\n  color: var(--secondaryColor);\n}\n\n.navActive > svg {\n  fill: var(--secondaryColor);\n}\n\n.subMenu:hover .subSubMenu {\n  display: block;\n  transition-duration: 0.5s;\n}\n\n.subMenu:hover .subSubMenu:hover {\n  display: block;\n  fill: var(--primaryColor);\n  color: var(--primaryColor);\n}\n\n.subSubMenu {\n  position: relative;\n  display: none;\n  top: 0;\n  /* right: -208px; */\n  background-color: #fff;\n  box-shadow: var(--shadow);\n  color: var(--fontColor);\n  border-radius: 5px;\n  z-index: 2;\n}\n\n/* =========== FOOTER NAV ================ */\n#footer {\n  background-color: var(--darkColour);\n  color: white;\n  padding: 25px;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto;\n  grid-template-rows: auto auto;\n  gap: 20px;\n  align-self: end;\n  justify-content: space-evenly;\n}\n\n#myDevDiv {\n  grid-column: 4;\n  grid-row: 1;\n  margin-top: 30px;\n}\n\n#eFeedbackDiv {\n  grid-column: 4;\n  grid-row: 1;\n}\n\n#footer h6 {\n  font-size: 14px;\n  line-height: 16px;\n}\n\n#footer p {\n  font-size: 12px;\n}\n\n#footer p:hover,\n#footer h6:hover {\n  color: var(--secondaryColor);\n  cursor: pointer;\n}\n\n#contact {\n  display: flex;\n}\n\n#contact div:first-of-type {\n  margin-right: 20px;\n}\n\n#footerLogo {\n  height: 110px;\n}\n\n#social {\n  display: flex;\n  margin-top: 21px;\n}\n\n#social > svg,\n#social > a > svg {\n  fill: white;\n  height: 14px;\n  width: auto;\n  margin-right: 14px;\n}\n\n#social > svg:hover,\n#social > a > svg:hover {\n  fill: var(--secondaryColor);\n  cursor: pointer;\n}\n\n#TCs {\n  grid-column: 5;\n  display: flex;\n  align-items: flex-end;\n}\n\n#TCs > a {\n  color: var(--fontLightColor);\n  font-size: 10px;\n  font-weight: 400;\n  text-align: right;\n  line-height: 14px;\n  text-decoration: none;\n}\n\n#TCs > a:hover {\n  color: var(--secondaryColor);\n}\n\n#TCs span {\n  cursor: pointer;\n}\n\n/* =========== COOKIES POP-UP =========== */\n\n#cookieBanner {\n  z-index: 2;\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 5px 40px;\n  position: fixed;\n  width: 80%;\n  background-color: var(--secondaryColor);\n  box-shadow: var(--shadow);\n  padding: 1.5rem;\n  border-radius: 10px;\n  bottom: 5%;\n}\n\n#cookieSVG {\n  height: 30px;\n  width: auto;\n  margin-right: 10px;\n  margin-top: -10px;\n}\n\n.cookieBtn {\n  font-family: var(--copyFont);\n  font-size: 15px;\n  color: white;\n  padding: 14px 30px;\n  background-color: var(--thirdColor);\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.cookieBtn:hover {\n  background-color: var(--fourthColour);\n  border: none;\n  outline: none;\n  color: white;\n  font-weight: bold;\n}\n\n.cookieX {\n  fill: var(--lightGrey);\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  z-index: 105 !important;\n  margin-left: 20px;\n  top: 12px;\n  right: 12px;\n}\n\n.cookieX:hover {\n  fill: var(--darkColour);\n}\n\n.pLink {\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.inline {\n  display: flex;\n  align-items: center;\n}\n\n.center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.grid2 {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 80px;\n  padding: 70px;\n}\n\n/* =============== NOTIFICATIONS ================= */\n/* --------- Notification popup ------------------ */\n.notify {\n  position: fixed;\n  top: 10px;\n  z-index: 102;\n}\n\n.noteIcon > svg {\n  fill: var(--primaryColor);\n  width: 30px;\n}\n\n.noteX {\n  color: var(--darkGrey);\n  cursor: pointer;\n}\n\n.notification {\n  position: relative;\n  background: white;\n  margin-top: 10px;\n  box-shadow: 0px 3px 6px #00000029;\n  padding: 3%;\n  left: -400px;\n  min-width: 250px;\n  max-width: 400px;\n  min-height: 35px;\n  border-right: solid;\n  border-width: 5px;\n  border-color: var(--primaryColor);\n  font-size: 14px;\n  opacity: 80%;\n  display: grid;\n  grid-template-columns: 15% 79% 6%;\n\n  /* Animation – Slide in*/\n  -webkit-animation: notification 0.5s forwards;\n  -webkit-animation-delay: 1s;\n  animation: notification 0.5s forwards;\n  animation-delay: 1s;\n}\n\n@-webkit-keyframes notification {\n  100% {\n    left: 20px;\n  }\n}\n\n@keyframes notification {\n  100% {\n    left: 20px;\n  }\n}\n\n/* ---------------- Error popup -------------------- */\n.popupBox {\n  position: fixed;\n  top: 30%;\n  left: 40%;\n  z-index: 100000;\n}\n\n.popupMsg {\n  position: relative;\n  background: white;\n  box-shadow: 0px 3px 6px #00000029;\n  padding: 10%;\n  width: 300px;\n  min-height: 200px;\n  border-top: solid 8px var(--errorColor);\n  font-size: 14px;\n  text-align: center;\n  z-index: 100000;\n}\n\n.msgHeading {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.popIconInfo > svg {\n  fill: var(--primaryColor);\n  width: 46px;\n}\n\n.popIconErr > svg {\n  fill: var(--errorColor);\n  width: 46px;\n}\n\n.overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.61);\n}\n\n.invisibleOverlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  z-index: 1;\n}\n\n.invisibleOverlay:hover {\n  background-color: transparent;\n}\n\n/* ----------information popup --------------------- */\n\n.popupBoxBig {\n  position: fixed;\n  top: 30%;\n  left: 40%;\n  z-index: 100;\n}\n\n.popupBoxContent {\n  position: relative;\n  width: 80%;\n  max-height: 90%;\n  padding: 40px;\n  top: 5%;\n  margin: auto;\n  background: white;\n  margin-top: 10px;\n  box-shadow: 0px 3px 6px #00000029;\n  overflow: auto;\n}\n\n.seeThroughOverlay {\n  position: fixed;\n  width: 1000px;\n  height: 100%;\n  top: 150px;\n  background-color: transparent;\n  z-index: 101;\n}\n\n.closeX {\n  padding-top: 7px;\n  color: #dadada;\n  font-size: 25px;\n  font-weight: bold;\n  text-align: center;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  float: right;\n  position: relative;\n  z-index: 105 !important;\n  margin-left: 20px;\n}\n\n.closeX:hover {\n  background-color: #e2e2e2;\n  color: white;\n  cursor: pointer;\n}\n\n/* ----------custom popup --------------------- */\n\n#custardBox {\n  position: fixed;\n  top: 30%;\n  left: 40%;\n  z-index: 100;\n}\n\n#custardContainer {\n  border-top: solid 8px var(--primaryColor);\n  position: relative;\n  width: 60%;\n  max-height: 80%;\n  padding: 40px;\n  top: 15%;\n  margin: auto;\n  background: white;\n  margin-top: 10px;\n  box-shadow: 0px 3px 6px #00000029;\n  overflow: auto;\n}\n\n#custardContent select {\n  margin-bottom: 0;\n}\n\n#custardContent {\n  text-align: center;\n}\n\n#custardContent .CCdigits {\n  margin-bottom: 0;\n}\n\n#custardContent .bar {\n  margin-top: 6px;\n}\n\n.x {\n  fill: var(--mediumGrey);\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  z-index: 105 !important;\n  margin-left: 20px;\n  top: 21px;\n  right: 21px;\n}\n\n.x:hover {\n  fill: var(--secondaryColor);\n  cursor: pointer;\n}\n\n#passCust {\n  margin-left: 2.5rem;\n  margin-top: 3rem;\n}\n\n/* #passCust .viewPass {\n    right: 90px;\n} */\n\n/* -----------Feedback Banner ----------*/\n#feedbackBanner,\n.feedbackBanner {\n  background-color: #db00001c;\n  border-left: 5px solid var(--errorColor);\n  width: 100%;\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 14px;\n  align-items: center;\n  text-align: left;\n  justify-content: start;\n  margin-bottom: 1rem;\n}\n\n.feedbackBannerGood {\n  background-color: var(--primaryColorOpacity) !important;\n  border-left: 5px solid var(--primaryColor) !important;\n}\n\n.feedbackBannerWarning {\n  background-color: var(--warningColorLight) !important;\n  border-left: 5px solid var(--warningColor) !important;\n}\n\n#feedback,\n.feedback {\n  color: var(--fontColor);\n  font-size: 11px;\n  line-height: 17px;\n}\n\n.xFeedback {\n  fill: var(--darkGrey);\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.xFeedback:hover {\n  fill: var(--fontColor);\n}\n\n/* =========== TABS =============== */\n\n.tab {\n  display: flex;\n  padding-bottom: 0px;\n  margin: 2.2rem 0px 20px 0px;\n  width: 90%;\n  overflow-x: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.tab button.active {\n  color: var(--fontColor);\n  font-weight: 700;\n  border-bottom: 3px solid var(--primaryColor);\n  padding-bottom: 12px;\n}\n\n.tab button:hover {\n  color: var(--secondaryColor);\n  font-weight: 700;\n}\n\n.tab button {\n  background-color: transparent;\n  color: var(--darkGrey);\n  /* min-width: 70px; */\n  border: none;\n  outline: none;\n  cursor: pointer;\n  margin-right: 35px;\n  transition: 0.5s;\n  font-family: var(--copyFont);\n  letter-spacing: var(--letterSpacingCopy);\n  white-space: nowrap;\n}\n\n.tabHR {\n  width: 90%;\n  position: relative;\n  top: -23px;\n  z-index: -1;\n}\n\n.scrollTabs {\n  position: relative;\n  width: 90%;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n#leftScroll {\n  left: 0;\n  position: absolute;\n  top: 50%;\n}\n\n#rightScroll {\n  right: 0;\n  position: absolute;\n  top: 50%;\n}\n\n/* Tablet */\n@media only screen and (max-width: 768px) {\n  .tab button {\n    font-size: 14px;\n    line-height: 20px;\n    background-color: transparent;\n    color: var(--darkGrey);\n    min-width: 50px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    margin-right: 1.5rem;\n    transition: 0.5s;\n    padding-bottom: 0.9rem;\n  }\n}\n\n/* Mobile */\n@media only screen and (max-width: 498px) {\n  .tab button {\n    font-size: 12px;\n    line-height: 22px;\n\n    margin-right: 1.4rem;\n    transition: 0.5s;\n    padding-bottom: 0rem;\n  }\n}\n\n/* Country Code */\n\n.CCdiv {\n  display: grid;\n  grid-template-columns: 100px auto;\n}\n\n.countryCodes {\n  width: 100px;\n  background-color: transparent;\n  min-width: unset;\n  padding-right: 4px;\n  border: none;\n  border-bottom: 2px solid var(--mediumGrey);\n}\n\n.CCdigits {\n  border-radius: 0px 3px 3px 0px !important;\n  border-left: none !important;\n  min-width: unset !important;\n  width: 209px;\n  padding-left: 10px !important;\n  /* margin-bottom: 0 */\n}\n\n/* Password Validation */\n#passValBox,\n#passMatchBox {\n  width: auto;\n  background-color: white;\n  padding: 1rem;\n  /* margin-top: 18px; */\n  box-shadow: var(--shadow);\n  position: relative;\n  z-index: 1;\n  top: -23px;\n}\n\n#passValBox:after,\n#passMatchBox::after {\n  content: '';\n  width: 20px;\n  height: 20px;\n  transform: rotate(-45deg);\n  background: #fff;\n  position: absolute;\n  top: -10px;\n  left: calc(10% - 10px);\n  /* box-shadow: var(--shadow); */\n}\n\n#passValBox > ul {\n  /* list-style-position: inside; */\n  /* @steph */\n  /* list-style-image: url(../assets/img/icons/cross.svg); */\n  text-align: left;\n  padding-left: 1rem;\n}\n\nli::marker {\n  fill: var(--primaryColor);\n  color: var(--primaryColor);\n}\n\n#passValBox > ul > li {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n#passValBox > h5 {\n  margin-bottom: 5px;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n}\n\n#passMatchBox > h5 {\n  color: var(--errorColor);\n  margin-bottom: 0;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n}\n\n/* tick & cross */\n.SVGbullet {\n  width: 10px;\n}\n\n/* eye */\n.viewPass {\n  width: 22px;\n  height: auto;\n  fill: var(--mediumGrey);\n  position: absolute;\n  cursor: pointer;\n  right: 12px;\n  top: 10px;\n}\n\n.iconOff {\n  fill: var(--mediumGrey);\n  cursor: pointer;\n}\n\n.iconOn {\n  fill: var(--primaryColor);\n}\n\n#capsLock {\n  width: 110px;\n  background-color: #fff;\n  padding: 5px;\n  box-shadow: var(--shadow);\n  position: absolute;\n  z-index: 10;\n}\n\n#capsLock > h6 {\n  font-size: 12px;\n  z-index: 11;\n  margin-bottom: 0;\n}\n\n#capsLock:after {\n  content: '';\n  width: 11px;\n  height: 11px;\n  transform: rotate(-45deg);\n  background: #fff;\n  position: absolute;\n  top: -5px;\n  left: calc(10% - -1px);\n  /* box-shadow: var(--shadow); */\n}\n\n/* =========== HOMEPAGE =============== */\n\n#intro {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  margin-right: 50px;\n  margin-top: 20px;\n}\n\n#myProfileLink {\n  color: var(--primaryColor);\n  cursor: pointer;\n}\n\n#myAssLink {\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.smallCards {\n  display: grid;\n  margin: 2rem;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 20px;\n  justify-content: center;\n}\n\n.gridSpan {\n  grid-column: 1 / -1;\n}\n\n.card {\n  background-color: white;\n  box-shadow: var(--shadow);\n  border-radius: 12px;\n  display: grid;\n  min-height: 100px;\n  max-width: 300px;\n  padding: 30px 20px 20px 20px;\n  text-align: center;\n  display: grid;\n  align-content: stretch;\n  grid-template-rows: 80px auto;\n  justify-content: center;\n}\n\n.cardSVG {\n  fill: var(--secondaryColor);\n}\n\n/* =========== PROFILE PAGE =============== */\n\n.editImgBtn {\n  cursor: pointer;\n  z-index: 1;\n  position: relative;\n  top: 105px;\n  left: 104px;\n}\n\n.profileImgContainer {\n  overflow: hidden;\n  position: relative;\n  border-radius: 50%;\n  height: 150px;\n  width: 150px;\n  border: 3px solid var(--secondaryColor);\n  background-color: var(--lightGrey);\n  top: -40px;\n  display: flex;\n  justify-content: center;\n}\n\n.profileImgContainer > img {\n  object-fit: cover;\n  text-align: center;\n}\n\n.passwordBtn {\n  font-family: var(--copyFont);\n  letter-spacing: var(--letterSpacingCopy);\n  font-size: 14px;\n  font-weight: 400;\n  color: #fff;\n  padding: 9px 18px;\n  background-color: var(--primaryColor);\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  text-transform: none;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0px;\n  left: 227px;\n}\n\n/* \n#fake_password {\n    width: 216px;\n} */\n\n.passwordBtn:hover {\n  background-color: var(--secondaryColor);\n  border: none;\n  outline: none;\n}\n\n/* ======= TOOLTIP =============== */\n\n.toolTip {\n  position: relative;\n  display: inline-block;\n}\n\n.toolTipText {\n  visibility: hidden;\n  width: inherit;\n  background-color: var(--secondaryColor);\n  color: var(--fontColor);\n  /* box-shadow: var(--shadow); */\n  text-align: center;\n  border-radius: 6px;\n  padding: 0.5rem;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: normal;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 2.5rem;\n}\n\n.toolTipText::after {\n  content: '';\n  width: 20px;\n  height: 20px;\n  transform: rotate(-45deg);\n  background-color: var(--secondaryColor);\n  position: absolute;\n  top: -0.5rem;\n  left: calc(20% - 10px);\n  /* box-shadow: var(--shadow); */\n}\n\n.toolTipTextTable {\n  visibility: hidden;\n  width: inherit;\n  /* min-width: 70px; */\n  background-color: var(--lightGrey);\n  color: var(--fontColor);\n  box-shadow: var(--shadow);\n  text-align: center;\n  border-radius: 6px;\n  padding: 0.5rem;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: normal;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n  left: -5px;\n  top: 2.5rem;\n}\n\n.toolTipTextTable::after {\n  content: '';\n  width: 15px;\n  height: 15px;\n  transform: rotate(-45deg);\n  background-color: var(--lightGrey);\n  position: absolute;\n  top: -0.4rem;\n  left: calc(100% - 65%);\n  /* box-shadow: var(--shadow); */\n}\n\n.test {\n  left: 0;\n  top: 3.5rem;\n}\n\n.toolTip:hover .toolTipText,\n.toolTip:hover .toolTipTextTable {\n  visibility: visible;\n}\n\n.iSVG,\n.iSVG > path {\n  fill: var(--fontLightColor) !important;\n  height: 14px;\n  width: auto;\n  cursor: pointer;\n}\n\n.appTip {\n  top: -10px;\n  left: -165px;\n  width: 150px;\n  padding-left: 0.7rem;\n  z-index: 100;\n}\n\n.appTip::after {\n  content: '';\n  width: 15px;\n  height: 15px;\n  transform: rotate(-45deg);\n  background-color: var(--secondaryColor);\n  position: absolute;\n  top: 0.7rem;\n  left: 142px;\n\n  /* box-shadow: var(--shadow); */\n}\n\n/* ------- TOOL TIP INPUT NO HOVER */\n\n.toolTip2 {\n  position: relative;\n  display: inline-block;\n}\n\n.toolTipText2 {\n  visibility: visible;\n  width: inherit;\n  background-color: var(--secondaryColor);\n  color: var(--fontColor);\n  /* box-shadow: var(--shadow); */\n  text-align: center;\n  border-radius: 6px;\n  padding: 0.5rem;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: normal;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 2.7rem;\n}\n\n.toolTipText2::after {\n  content: '';\n  width: 15px;\n  height: 15px;\n  transform: rotate(-45deg);\n  background-color: var(--secondaryColor);\n  position: absolute;\n  top: -0.4rem;\n  left: calc(20% - 10px);\n  /* box-shadow: var(--shadow); */\n}\n\n/* =========== MY MESSAGES PAGE =============== */\n\n.msgGrid {\n  display: grid;\n  grid-template-columns: 40% 60%;\n  gap: 0px;\n  padding: 1rem;\n  width: -webkit-fill-available;\n  margin: 0 3rem 3rem 3rem;\n}\n\n/* Left */\n#msgs {\n  padding: 2rem;\n  background-color: var(--lightGrey);\n  border-radius: 11px;\n}\n\n#listMsgs {\n  /* padding: 1rem; */\n  margin: 0.5rem;\n}\n\n.msg {\n  padding: 1rem;\n  position: relative;\n  border-radius: 11px;\n  cursor: pointer;\n}\n\n.msg:hover {\n  background-color: var(--primaryColorOpacity);\n}\n\n.msgActive {\n  background-color: white;\n  box-shadow: var(--shadow);\n}\n\n.msgActive:hover {\n  background-color: white;\n}\n\n.msgDate {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  font-size: 12px;\n  color: var(--darkGrey);\n}\n\n.msgSubject {\n  color: var(--primaryColor);\n  margin-bottom: 0.3rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 12px;\n  font-weight: 600;\n}\n\n.msgActive .msgSubject {\n  color: var(--secondaryColor);\n}\n\n.msgPreview {\n  font-size: 13px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* right */\n#msgDetail {\n  padding: 0 3rem;\n}\n\n#msgDDate {\n  color: var(--mediumGrey);\n  font-size: 13px;\n}\n\n#msgDSubject {\n  margin: 0.8rem 0 !important;\n}\n\n#msgDWho > span {\n  font-weight: 600;\n}\n\n#msgBack {\n  display: none;\n  margin-bottom: 1rem;\n  cursor: pointer;\n}\n\n.backChev {\n  fill: var(--fontColor);\n  width: 14px;\n  height: auto;\n  transform: rotate(90deg);\n}\n\n@media only screen and (max-width: 1100px) {\n  .msgGrid {\n    display: grid;\n    grid-template-columns: 40% 60%;\n    gap: 0px;\n    padding: 1rem;\n    width: -webkit-fill-available;\n    margin: 0 1rem 1rem 1rem;\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .msgGrid {\n    display: grid;\n    grid-template-columns: 100%;\n    padding: 0;\n    margin: 0;\n    border-radius: 0;\n  }\n\n  #msgDetail {\n    display: none;\n  }\n\n  #msgs {\n    padding: 2rem;\n    border-radius: 0;\n  }\n\n  #msgBack {\n    display: block;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  #msgs {\n    padding: 2rem 1rem;\n  }\n}\n\n/* =========== GUIDE PAGE =============== */\n\n.tabcontent {\n  width: 100%;\n}\n\n.stepsBlock {\n  border-left: 2px solid var(--secondaryColor);\n  padding-left: 50px;\n  position: relative;\n  margin: 20px 0px;\n  /* width: 100%; */\n}\n\n.stepsBlock > div {\n  margin-bottom: 2.5rem;\n}\n\n.stepsBlock h6 {\n  margin-bottom: 0.2rem;\n}\n\n.stepsBlock p {\n  margin-bottom: 1rem;\n  font-size: 12px;\n}\n\n.stepNum {\n  position: absolute;\n  left: -19px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  background-color: var(--secondaryColor);\n  border-radius: 20px;\n  width: 35px;\n  height: 35px;\n  font-size: 20px;\n}\n\n.linkP {\n  cursor: pointer;\n  color: var(--primaryColor);\n}\n\n.link:hover {\n  color: var(--secondaryColor);\n}\n\n.link {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: var(--primaryColor);\n  fill: var(--primaryColor);\n}\n\n.link:hover {\n  color: var(--secondaryColor);\n  fill: var(--secondaryColor);\n}\n\n.link > svg {\n  height: 30px;\n  width: auto;\n  margin-right: 5px;\n}\n\n/* =========== CONSENT PAGE =============== */\n\n.optBlock {\n  width: fit-content;\n  text-align: center;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.checkSVG {\n  fill: grey;\n}\n\n.checkSVG > svg {\n  height: 27px !important;\n  width: auto;\n}\n\n.checkSVG:hover {\n  fill: var(--primaryColor);\n}\n\n.arrowDD {\n  fill: var(--firstColor);\n  width: 11px;\n  height: auto;\n}\n\n.arrowDown {\n  transform: rotateZ(90deg);\n}\n\n.formContainer {\n  margin-bottom: 2rem;\n}\n\n.consentName {\n  display: flex;\n  padding: 12px 30px;\n  align-items: center;\n  cursor: pointer;\n  background-color: var(--primaryColor);\n  border-radius: 20px;\n  margin-top: 20px;\n}\n\n.consentName > svg {\n  margin-right: 10px;\n  fill: white;\n}\n\n.consentName > h5 {\n  margin: 0 !important;\n  color: white;\n}\n\n.textContainer {\n  padding: 30px;\n  cursor: pointer;\n  background-color: white;\n  border-radius: 0px 0px 20px 20px;\n  box-shadow: var(--shadow);\n}\n\n.textContainer ul,\n.textContainer ol {\n  margin-left: 20px;\n}\n\n.textContainer ul > li,\n.textContainer ol > li {\n  line-height: 21px;\n}\n\n.textContainer p {\n  margin-bottom: 17px;\n}\n\n.borderR {\n  border-radius: 20px 20px 0px 0px;\n}\n\n.oldBox {\n  border: 2px solid #d3d3d3;\n  border-radius: 6px 6px 0 0;\n  box-shadow: 0 0 15px lightgrey;\n  padding: 10px;\n}\n\n.labelRow > .row {\n  align-items: baseline;\n  margin-bottom: 14px;\n}\n\n.labelRow > .row > label {\n  width: 35%;\n  font-weight: bold;\n  line-height: 18px;\n  font-size: 14px;\n}\n\n#assDets li {\n  font-weight: 400;\n}\n\n#assDets span {\n  font-weight: 700;\n}\n\n/* =========== ASSESSMENTS PAGE =============== */\n\n.blockTabs {\n  display: flex;\n  margin: 0 4rem 2rem 4rem;\n  border-radius: 10px;\n  border: 3px solid var(--primaryColor);\n  width: fit-content;\n}\n\n.blockTabs > div {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-right: 3px solid var(--primaryColor);\n  color: var(--primaryColor);\n  fill: var(--primaryColor);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.blockTabs > div > svg {\n  margin-right: 0.6rem;\n  height: 27px;\n  width: auto;\n}\n\n.blockTabs > div:last-child {\n  border: none;\n  border-right: none;\n}\n\n.blockActive {\n  color: white !important;\n  fill: white !important;\n  background-color: var(--primaryColor);\n}\n\n/* =========== MY DEVELOPMENT PAGE =============== */\n\n.graphics {\n  height: 350px;\n  width: auto;\n  position: relative;\n}\n\n#bookImg {\n  top: -65px;\n}\n\n#targetImg {\n  top: -20px;\n}\n\n.finePrint {\n  font-size: 11px;\n  color: var(--mediumGrey);\n}\n\n@media only screen and (max-width: 910px) {\n  .graphics {\n    height: 350px;\n    width: auto;\n    position: relative;\n  }\n\n  #bookImg {\n    top: 2rem;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .graphics {\n    height: 230px;\n    width: auto;\n    position: relative;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .graphics {\n    height: 180px;\n    width: auto;\n    position: relative;\n  }\n}\n\n.cardCliclickable:hover {\n  cursor: pointer;\n  background-color: var(--trHover);\n  color: var(--darkColour) !important;\n}\n\n.cardActive {\n  background-color: var(--primaryColorOpacity);\n  color: var(--darkColour) !important;\n}\n\n.cardActive h5 {\n  font-weight: 700;\n}\n\n.ulResources {\n  padding-left: 1.5rem;\n  margin-top: 1.5rem;\n  text-align: left;\n}\n\n.ratingStar {\n  fill: var(--primaryColor);\n  cursor: pointer;\n  margin-right: 5px;\n}\n\n#resourceTable tr:hover {\n  background-color: #fff;\n}\n\n/* =========== eFEEDBACK PAGE =============== */\n\n.imgCards {\n  display: flex;\n  padding: 50px;\n  gap: 20px;\n  justify-content: center;\n  margin: auto;\n}\n\n.imgCards .card {\n  padding: unset;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.card button {\n  margin: unset;\n}\n\n.card img {\n  object-fit: cover;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: 100%;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  height: 200px;\n  min-height: 200px;\n  width: 250px;\n  max-width: 300px;\n}\n\n.cardInfo {\n  padding: 2rem;\n}\n\n#myForm {\n  position: relative;\n  z-index: 2;\n  display: flex;\n}\n\n#logo_speel {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n#duplicateBtn {\n  position: absolute;\n  border: none;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  right: 0;\n}\n\n#duplicateBtn > svg {\n  height: 25px;\n  width: auto;\n  margin-right: 10px;\n}\n\n#duplicateBtn:hover {\n  color: var(--primaryColor);\n  fill: var(--primaryColor);\n  cursor: pointer;\n}\n\n/* ================== ASSIGN ASSESSMENT PAGE ======================= */\n\n.whiteBox {\n  background: #f8f8f8;\n  box-shadow: 0px 2px 6px #00000041;\n  border-radius: 10px;\n  opacity: 1;\n  padding: 3%;\n  margin-top: 30px;\n  width: 100%;\n}\n\n.grid-container-3col {\n  display: grid;\n  grid-template-columns: 25% 1fr 15%;\n  grid-gap: 35px 40px;\n  /* box-sizing: content-box; */\n  width: 100%;\n}\n\n.grid-3col-aapage {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 1fr;\n  gap: 1rem;\n  align-items: center;\n}\n\n/* @media (max-width: 1620px) {\n    .grid-container-3col-even {\n        display: grid;\n        grid-template-columns: 50% 50%;\n    }\n} */\n\n/* ==============================================================\n==================== RESPONSIVE ================================================================= */\n\n@media only screen and (max-width: 1200px) {\n  #logo_speel {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-around;\n    gap: 2rem;\n    align-items: center;\n  }\n\n  #supportBlock {\n    grid-column: 2/3;\n    grid-row: 1;\n    width: 100%;\n    box-shadow: none;\n    border-radius: 10px;\n    z-index: 11;\n    display: grid;\n    grid-template-columns: auto;\n    gap: 60px;\n    padding: 3rem;\n  }\n\n  #left {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-around;\n  }\n\n  .grid-3col {\n    display: grid;\n    justify-content: center;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem 3rem;\n    align-items: center;\n    justify-items: center;\n    margin: 0 2rem;\n  }\n}\n\n/* Small Desktop */\n@media only screen and (max-width: 1000px) {\n  #footerLogo {\n    height: 100px;\n  }\n\n  #footer h6 {\n    font-size: 12px;\n    line-height: 14px;\n  }\n\n  #footer p {\n    font-size: 10px;\n    line-height: 21px;\n  }\n\n  #TCs p {\n    font-size: 9px;\n    line-height: 14px;\n  }\n\n  .smallCards {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  #intro {\n    display: grid;\n    grid-template-columns: 1fr;\n    justify-items: center;\n    margin: 0px 50px 50px 50px;\n    text-align: center;\n  }\n\n  #candiNav > div,\n  #adminNav > div {\n    margin: 0 1rem;\n  }\n\n  #supportBlock {\n    padding: 2rem;\n  }\n}\n\n@media only screen and (max-width: 910px) {\n  input {\n    /* width: 255px; */\n    width: 100%;\n  }\n\n  select {\n    /* width: 255px; */\n    width: 100%;\n  }\n}\n\n/* Tablet */\n@media only screen and (max-width: 768px) {\n  .grid-container-3col {\n    grid-template-columns: 1fr;\n  }\n\n  /* login */\n\n  #coverImg {\n    display: none;\n  }\n\n  .loginContent {\n    text-align: left;\n    grid-column: 1 / span all;\n    grid-row: 1;\n    width: 90%;\n    height: 100vh;\n    background: #fff;\n    box-shadow: none;\n    z-index: 11;\n    justify-content: center;\n  }\n\n  input {\n    /* width: 255px; */\n    width: 100%;\n  }\n\n  select {\n    /* width: 255px; */\n    width: 100%;\n  }\n\n  .bar {\n    width: 100%;\n  }\n\n  #intLogoDesk {\n    /* content: url('integrateLogo_white_Moboile.svg'); */\n  }\n\n  #supportBlock {\n    grid-column: 2/3;\n    grid-row: 1;\n    width: 100%;\n    box-shadow: none;\n    border-radius: 10px;\n    z-index: 11;\n    display: grid;\n    grid-template-columns: auto;\n    gap: 60px;\n    padding: 2rem;\n  }\n\n  #right {\n    grid-template-columns: 1fr;\n    gap: 5px 30px;\n    margin-top: 0px;\n  }\n\n  /* Footer */\n  #footer {\n    grid-template-columns: auto auto auto;\n    grid-template-rows: auto auto;\n    gap: 10px;\n  }\n\n  #TCs p {\n    text-align: center;\n  }\n\n  #TCs {\n    grid-column: 1/5;\n    grid-row: 3;\n    align-self: end;\n    justify-self: center;\n    margin-top: 10px;\n  }\n\n  #TCs > a {\n    text-align: center;\n  }\n\n  #myProfileDiv {\n    grid-column: 2;\n    grid-row: 1;\n  }\n\n  #maAssDiv {\n    grid-column: 3;\n    grid-row: 1;\n  }\n\n  #eFeedbackDiv {\n    grid-column: 2;\n    grid-row: 1;\n    margin-top: 100px;\n  }\n\n  #myDevDiv {\n    grid-column: 3;\n    grid-row: 1;\n    margin-top: 100px;\n  }\n\n  #homepageComputer {\n    width: 400px;\n    height: auto;\n  }\n\n  .cardSVG {\n    width: 45px;\n    height: auto;\n  }\n\n  .card {\n    display: grid;\n    align-content: stretch;\n    grid-template-rows: 65px auto;\n    justify-content: center;\n  }\n\n  /* cookies */\n\n  #cookieBanner {\n    width: 90%;\n    bottom: 3%;\n  }\n\n  .cookieBtn {\n    height: 50px;\n  }\n\n  #loginBtn,\n  #forgotPassBtn,\n  #ssoBtn {\n    width: 321px;\n  }\n}\n\n/* Small tablet*/\n@media only screen and (max-width: 600px) {\n  .loginHeading {\n    width: 100%;\n  }\n\n  #loginDiv {\n    width: 100%;\n  }\n\n  #loginBtn,\n  #forgotPassBtn,\n  #ssoBtn {\n    width: 100%;\n  }\n\n  #logo_speel {\n    flex-direction: column;\n  }\n}\n\n/* Mobile */\n@media only screen and (max-width: 480px) {\n  .loginContent {\n    width: 100%;\n  }\n\n  #supportBlock {\n    gap: 50px;\n  }\n\n  .smallCards {\n    grid-template-columns: 1fr;\n  }\n\n  #right {\n    grid-template-columns: 1fr;\n    gap: 5px 30px;\n    margin-top: 0px;\n  }\n\n  input {\n    width: 100%;\n  }\n\n  /* Footer */\n  #footer {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto auto auto;\n    gap: 20px;\n    justify-content: space-evenly;\n    padding: 7% 10%;\n  }\n\n  #contact {\n    grid-column: 1/3;\n    grid-row: 3;\n    align-self: center;\n    justify-self: center;\n    border-top: 2px solid #fff;\n    padding-top: 20px;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: center;\n    padding-top: 36px;\n    margin-top: 10px;\n  }\n\n  #footer h6 {\n    font-size: 15px;\n    line-height: 16px;\n  }\n\n  #footer p {\n    font-size: 13px;\n    line-height: 25px;\n  }\n\n  #footerLogo {\n    height: 105px;\n    margin-right: 1rem;\n  }\n\n  #social {\n    display: flex;\n    margin-top: 10px;\n  }\n\n  #social > svg {\n    fill: white;\n    height: 21px;\n    width: auto;\n    margin-right: 21px;\n  }\n\n  #f_ContactUs {\n    display: none;\n  }\n\n  #f_supportEmail,\n  #f_supportNum {\n    font-size: 15px !important;\n    line-height: 28px !important;\n  }\n\n  #TCs p {\n    font-size: 11px;\n    text-align: center;\n    line-height: 19px;\n  }\n\n  #TCs {\n    grid-column: 1/3;\n    grid-row: 4;\n    align-self: end;\n    justify-self: center;\n    /* margin-top: 12px; */\n    margin: 1rem;\n  }\n\n  #myProfileDiv {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  #maAssDiv {\n    grid-column: 2;\n    grid-row: 1;\n  }\n\n  #eFeedbackDiv {\n    grid-column: 1;\n    grid-row: 2;\n    margin-top: 0;\n  }\n\n  #myDevDiv {\n    grid-column: 2;\n    grid-row: 2;\n    margin-top: 0;\n  }\n\n  #homepageComputer {\n    width: 350px;\n    height: auto;\n  }\n\n  /* Top Nav */\n\n  #nav {\n    /* position: absolute; */\n    width: 100%;\n  }\n\n  #mainContent {\n    top: 45px;\n  }\n\n  #logos {\n    grid-column: 1/2;\n    grid-row: 1;\n  }\n\n  #candiNav {\n    flex-direction: column;\n    grid-column: 1 / 5;\n    padding: 1rem;\n    z-index: 11;\n    background-color: var(--primaryColor);\n    width: 100%;\n    display: none;\n  }\n\n  #bar2 {\n    display: none;\n  }\n\n  #adminNav {\n    flex-direction: column;\n    display: none;\n  }\n\n  #homeBtn {\n    display: block !important;\n  }\n\n  #candiNav > div,\n  #adminNav > div {\n    margin: 0.5rem;\n  }\n\n  /* cookies */\n\n  #cookieBanner {\n    grid-template-columns: auto;\n    gap: 0px;\n    width: 100%;\n    box-shadow: none;\n    padding: 1rem;\n    border-radius: 0px;\n    bottom: 0;\n    text-align: center;\n  }\n\n  #cookieBanner > div {\n    justify-content: center;\n  }\n\n  #cookieSVG {\n    height: 22px;\n    width: auto;\n  }\n\n  .cookieBtn {\n    font-size: 14px;\n    color: white;\n    padding: 8px 30px;\n    height: 40px;\n    margin-top: 13px;\n  }\n\n  #cookieContainer {\n    bottom: 0;\n  }\n}\n\n/* ===== Record App ===== */\n.RVli,\n.HRli,\n.HRli {\n  /* display: flex; */\n  position: relative;\n  margin-left: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.trash > svg {\n  height: 1.1rem;\n  width: auto;\n  cursor: pointer;\n  fill: var(--primaryColor);\n  margin-left: 0.9rem;\n  position: absolute;\n  top: -2px;\n}\n\ntd .trash > svg {\n  position: unset;\n  top: unset;\n  margin-left: unset;\n}\n\n.trash > svg:hover {\n  fill: var(--secondaryColor);\n}\n\n#assPackMsg,\n#legalMsg {\n  color: var(--errorColor);\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 0.5rem;\n}\n\n.inputNote {\n  color: var(--errorColor);\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 0.3rem;\n  margin-bottom: 0.3rem;\n}\n\n/* ------------------Admin Reports ------------------------- */\n\n.controlPanelGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  width: 100%;\n  margin-top: 1.2rem;\n}\n\n.box {\n  background-color: var(--lightGrey);\n  box-shadow: var(--shadow);\n  border-radius: 12px;\n  position: relative;\n  width: 100%;\n  padding: 2rem;\n}\n\n.boxInpt {\n  border: 2px solid var(--mediumGrey);\n  background-color: white;\n}\n\n.subBox {\n  background-color: var(--primaryColorOpacity);\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 2rem;\n}\n\n.subBox input,\n.subBox select {\n  border-color: var(--darkGrey);\n}\n\n/* .box input {\n    border: 2px solid var(--mediumGrey);\n    background-color: #fff;\n} */\n\n.noteBox {\n  background-color: var(--primaryColorOpacity);\n  color: var(--fontColor);\n  padding: 1.5rem;\n  border-radius: 20px;\n  box-shadow: 0px 2px 6px #00000028;\n}\n\n@media only screen and (max-width: 1400px) {\n  .controlPanelGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .controlPanelGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tgglLabel {\n  color: var(--fontColor);\n}\n\n.reportChart {\n  width: minmax(auto, 1200px);\n  height: auto;\n  margin-bottom: 3rem;\n}\n\n.reportChart > canvas {\n  position: relative;\n}\n\n/* Steps -> month slider */\n\n.rating {\n  margin: 1rem 0 3.5rem 0;\n}\n\n.rating > p:first-of-type {\n  margin-bottom: 1rem;\n}\n\n.ratingSteps1 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.ratingItem {\n  background-color: var(--mediumGrey);\n  border-radius: 30px;\n  width: 40px;\n  height: 40px;\n  color: #fff;\n  text-align: center;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 0;\n}\n\n.ratingLine {\n  width: 100%;\n  border: 4px solid var(--mediumGrey);\n  background-color: var(--mediumGrey);\n  margin-bottom: unset;\n}\n\n.selected {\n  border-color: var(--secondaryColor);\n  background-color: var(--secondaryColor);\n}\n\n.ratingActive {\n  background-color: var(--secondaryColor);\n  border-color: var(--secondaryColor);\n}\n\n.resultsNote {\n  display: inline-flex;\n  align-items: flex-start;\n  margin-top: 40px;\n  background-color: #d1d2d4;\n  padding: 16px;\n  border-radius: 7px;\n}\n\n.resultsNote > div {\n  margin-right: 18px;\n}\n\n.resultsNote > div > p {\n  font-size: 13px;\n  line-height: 19px;\n}\n\n.ugFilters,\n.legFilters {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.filterTag {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  margin-right: 0.6rem;\n  background-color: var(--primaryColorOpacity);\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.filterTag svg {\n  margin-left: 0.5rem;\n  width: 20px;\n}\n\n/* ---------------------- Application Detail ------------- */\n\n.detailCard {\n  background-color: var(--lightGrey);\n  box-shadow: var(--shadow);\n  border-radius: 12px;\n  position: relative;\n  width: 100%;\n  padding: 2rem;\n  text-align: left;\n  display: grid;\n  grid-template-columns: 1fr 2fr 0.8fr 2fr;\n  gap: 0.7rem 1rem;\n}\n\n.detailInfo {\n  position: relative;\n  width: 100%;\n  text-align: left;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 0.5rem;\n}\n\n@media only screen and (max-width: 1100px) {\n  .detailCard {\n    background-color: var(--lightGrey);\n    box-shadow: var(--shadow);\n    border-radius: 12px;\n    position: relative;\n    width: 100%;\n    padding: 2rem;\n    text-align: left;\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    gap: 0.7rem;\n  }\n\n  .detailInfo {\n    grid-template-columns: 1fr 2fr;\n    gap: 0.5rem;\n  }\n}\n\n.addInfoBox-2col {\n  background-color: #f5f5f5;\n  border-radius: 13px;\n  padding: 2.5rem 2rem 1rem 2rem;\n  width: 100%;\n  margin: 1.5rem;\n  position: relative;\n  right: 34px;\n  align-items: start;\n}\n\n.addInfoBox-2col label,\n#newRequester label {\n  color: black;\n}\n\n#APOquestions {\n  background-color: #f5f5f5;\n  border-radius: 13px;\n  width: 100%;\n  padding: 1.5rem;\n  margin-top: 1.5rem;\n  position: relative;\n}\n\n#APOquestions p {\n  line-height: 17px;\n  margin-bottom: 1rem;\n}\n\n/* ------------- Contact Form -------------------------- */\n.CFgrid {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* ------------- Add report -------------------------- */\n\n.layoutReports {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 3rem;\n  box-sizing: content-box;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1100px) {\n  .layoutReports {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n}\n\n.subBox1 {\n  background: var(--lightGrey);\n  color: var(--fontColor);\n  grid-column: 2;\n  padding: 43px;\n  border-radius: 20px;\n  box-shadow: 0px 2px 6px #00000028;\n  margin-bottom: 2rem;\n}\n\n.resultsGrid {\n  display: grid;\n  grid-template-columns: 285px auto auto;\n  grid-gap: 35px 30px;\n  box-sizing: content-box;\n  align-items: end;\n}\n\n.resultsGrid4Col {\n  display: grid;\n  grid-template-columns: 200px auto auto auto;\n  grid-gap: 35px 30px;\n  box-sizing: content-box;\n  align-items: end;\n}\n\n.inputResults > div {\n  display: inline-flex !important;\n  align-items: center !important;\n  margin-bottom: 8px;\n}\n\n.inputResults > div > h4 {\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.inputResults > div > input:focus {\n  outline: none !important;\n  border-top: transparent !important;\n  border-left: transparent !important;\n  border-right: transparent !important;\n}\n\n.inputResults > div > .correct {\n  border-color: #1d9f86 !important;\n}\n\n.inputResults > div > .incorrect {\n  border-color: var(--errorColor) !important;\n}\n\n.inputResults > div > input {\n  font-family: 'Open Sans', Arial, Helvetica, sans-serif;\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  height: 25px;\n  width: 60px;\n  margin: 0;\n  border: none;\n  border-bottom: solid 2px !important;\n  border-radius: 0px !important;\n  border-color: var(--mediumGrey) !important;\n  outline: none;\n  min-width: unset;\n  text-align: center;\n  padding: 0px !important;\n}\n\n.dashInput > input {\n  width: 32px !important;\n}\n\n.feilds > h4 {\n  font-weight: normal;\n  margin-bottom: 0px;\n  margin-top: 14.5px;\n  font-size: 14px;\n}\n\n.resultsNote {\n  display: inline-flex;\n  align-items: flex-start;\n  margin-top: 40px;\n  background-color: #d1d2d4;\n  padding: 16px;\n  border-radius: 7px;\n}\n\n.resultsNote > div {\n  margin-right: 18px;\n}\n\n.resultsNote > div > p {\n  font-size: 13px;\n  line-height: 19px;\n}\n\n/* Steps */\n\n.steps {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.step {\n  background-color: var(--mediumGrey);\n  border-radius: 20px;\n  width: 30px;\n  height: 30px;\n  color: white;\n  text-align: center;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 4px;\n}\n\n.stepLine {\n  width: 60px;\n  border: 1.5px solid var(--mediumGrey);\n  background-color: var(--mediumGrey);\n  margin: unset;\n}\n\n.bgActive {\n  background-color: var(--primaryColor);\n}\n\n.hrActive {\n  border: 1.5px solid var(--primaryColor);\n  background-color: var(--primaryColor);\n}\n\n/* List Table */\n\n.listHead > tr > th {\n  color: var(--fontColor);\n  background-color: white;\n  font-size: 14px !important;\n  padding: 10px 5px !important;\n}\n\n.listBody {\n  background-color: white;\n}\n\n.listBody > tr {\n  border-bottom: none !important;\n  padding-top: 10px;\n  text-align: center;\n}\n\n.listBody > tr > td {\n  text-align: center;\n  padding: 8px !important;\n}\n\na:hover,\ntd > img:hover {\n  cursor: pointer;\n}\n\na > svg:hover {\n  fill: var(--primaryColor);\n}\n\n/* ---------------------viewApp page ------------------------ */\n#scientistQs img {\n  max-width: 20px;\n  height: auto;\n}\n\n/* --------------------Drag & Drop --------------------------- */\n.draggable {\n  background-color: white;\n  box-shadow: 0px 2px 6px #00000041;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  width: 800px;\n  padding: 15px;\n  margin: 10px 0px;\n  width: 100%;\n  max-width: 800px;\n  align-items: center;\n}\n\n.draggable::after,\n.draggable::before {\n  margin: unset;\n}\n\n.draggable:hover {\n  background-color: var(--primaryColorOpacity);\n  cursor: pointer;\n}\n\n.draggable.dragging {\n  background-color: var(--primaryColorOpacity);\n  cursor: move;\n}\n\n.barLeft {\n  display: inline-flex;\n  margin-right: 20px;\n}\n\n.barRight {\n  float: right;\n}\n\n.dragDots {\n  margin-right: 1.5rem;\n  fill: var(--primaryColor);\n  color: var(--primaryColor);\n  width: 5px;\n  height: auto;\n}\n\n/*  drag & drop in a table */\n.Tdraggable {\n  background-color: transparent;\n  box-shadow: unset;\n  border-radius: unset;\n  display: unset;\n  justify-content: unset;\n  width: unset;\n  padding: unset;\n  margin: unset;\n  width: 100%;\n  max-width: unset;\n  align-items: unset;\n}\n\n.Tdraggable::after,\n.Tdraggable::before {\n  margin: unset;\n}\n\n.Tdraggable:hover {\n  background-color: var(--trHover_);\n  cursor: pointer;\n}\n\n.Tdraggable.dragging {\n  background-color: var(--trHover_);\n  cursor: move;\n}\n\n.TbarDots {\n  object-fit: none;\n  margin-left: 20px;\n  margin-top: 16px;\n}\n\n/* =========================== LMS ====================== */\n\n#lmsContainer {\n  width: 100vw;\n  height: 100vh;\n  /* height: auto; */\n  box-sizing: border-box;\n  margin: 0;\n  border: none;\n  padding: 50px;\n}\n\n/* ---------Compare Users --------------------------- */\n\n#compareBtn {\n  float: left;\n  margin-bottom: 12px;\n  display: flex;\n}\n\n.compareGrid {\n  display: grid;\n  grid-template-columns: 150px auto;\n  grid-gap: 35px 20px;\n  box-sizing: content-box;\n  width: 100%;\n}\n\n.hrCompare {\n  margin: 0px 0px 25px 0px;\n  border: 1px solid #cccccc;\n}\n\n.compareLabels {\n  color: var(--primaryColor);\n  margin-top: 309px;\n}\n\n.compareLabels > h4 {\n  margin: 9.9px 0px;\n  font-size: 14px;\n}\n\n.compareProfile {\n  background: white;\n  color: var(--fontColor);\n  grid-column: 2;\n  padding: 30px;\n  border-radius: 20px;\n  width: fit-content;\n  box-shadow: 0px 2px 6px #00000041;\n  min-width: 260px;\n}\n\n.compareProfileActive {\n  background: var(--primaryColor);\n  color: white;\n  grid-column: 2;\n  padding: 30px;\n  border-radius: 20px;\n  width: fit-content;\n  min-width: 260px;\n  box-shadow: 0px 2px 6px #00000041;\n}\n\n.profileDets > p {\n  color: var(--fontColor);\n  font-size: 11px;\n  line-height: 18px;\n  font-weight: lighter;\n}\n\n.profileDetsActive > p {\n  color: white;\n  font-size: 11px;\n  line-height: 18px;\n  font-weight: lighter;\n}\n\n.profileDets > h4 {\n  font-size: 17px;\n  margin-bottom: 7px;\n}\n\n.profileDetsActive > h4 {\n  font-size: 17px;\n  margin-bottom: 7px;\n  color: white;\n}\n\n.compareProfileActive > .userinfo > label {\n  color: white !important;\n}\n\n.userinfo > label {\n  text-transform: none;\n  font-weight: lighter;\n}\n\n.selectedCU {\n  font-weight: bold;\n}\n\n.assNapp {\n  margin: 20px 0px 26px 26px;\n}\n\n.compareli {\n  font-size: 11px;\n  list-style: none;\n  font-weight: bold;\n}\n\n.compareli > li {\n  line-height: 8px;\n  font-size: 11px;\n  color: var(--primaryColor);\n}\n\n.compareSubli {\n  margin: 7px 0px 7px 15px;\n  font-size: 11px;\n}\n\n.compareSubli > li {\n  line-height: 13px;\n  font-size: 11px;\n  font-weight: normal;\n}\n\n#ppic_0,\n#ppic_1,\n#ppic_2 {\n  position: absolute;\n  width: 100px;\n  top: -1px;\n  left: -1px;\n}\n\n.ppContainer {\n  overflow: hidden;\n  position: relative;\n  border-radius: 50%;\n  height: 100px;\n  width: 100px;\n  border: 2.5px solid var(--primaryColor);\n  background-color: white;\n  padding: 3px;\n}\n\n.imgTick {\n  position: absolute;\n  cursor: pointer;\n  z-index: 1;\n  margin-left: 65px;\n  margin-top: 54px;\n  width: 42px;\n}\n\n.fillWhite {\n  fill: #fff;\n}\n\n.fillSecColour {\n  fill: var(--secondaryColor);\n}\n\n.ppActive {\n  border: 3px solid var(--secondaryColor);\n}\n\n/* ---Checkbox on green bg ---*/\n.compareProfileActive > .userinfo > .checkContainer input ~ .tick {\n  border: 2px solid white;\n}\n\n.compareProfileActive > .userinfo > .checkContainer input:checked ~ .tick {\n  background-color: white;\n}\n\n.compareProfileActive > .userinfo > .checkContainer .tick:after {\n  border: solid var(--primaryColor);\n  border-width: 0 2px 2px 0;\n}\n\n/* ---Checkbox not valid ---*/\n.compareProfile > .userinfo > .checkContainer input:checked ~ .na {\n  background-color: #d3d3d3;\n}\n\n.compareProfile > .userinfo > .checkContainer .na:after {\n  border: solid #d3d3d3;\n  border-width: 0 2px 2px 0;\n}\n\n.compareProfileActive > .userinfo > .checkContainer input ~ .na {\n  border: 2px solid #8d8d8d;\n}\n\n.compareProfileActive > .userinfo > .checkContainer input:checked ~ .na {\n  background-color: #d3d3d3;\n}\n\n.compareProfileActive > .userinfo > .checkContainer .na:after {\n  border: solid #d3d3d3;\n  border-width: 0 2px 2px 0;\n}\n\ninput ~ .na {\n  border: 2px solid #8d8d8d;\n  background-color: #d3d3d3;\n}\n\ninput:checked ~ .na {\n  background-color: #d3d3d3;\n  border: 2px solid #8d8d8d;\n}\n\n.na:after {\n  border: solid #d3d3d3;\n  border-width: 0 2px 2px 0;\n}\n\n.checkContainer:hover input ~ .na {\n  background-color: #d3d3d3;\n  cursor: none;\n}\n\n.checkContainer .na:after {\n  border: solid #d3d3d3;\n  border-width: 0 2px 2px 0;\n}\n\n.fyi {\n  background-color: #d1d2d4;\n  padding: 16px;\n  max-width: 350px;\n  border-radius: 7px;\n}\n\n.fyi > p {\n  font-size: 12px;\n  line-height: 20px;\n}\n\n#eFeedbackLms {\n  margin-top: 4rem;\n  min-height: 65vh;\n}\n\n#allocatedCourses {\n\n}\n\n.jvrLmsCourseContainer {\n  margin: 0 4rem;\n}\n\n.no-lms-data-error {\n  margin: 0 4rem;\n}\n\n.vimeoContainer {\n  overflow: hidden;\n  /* 16:9 aspect ratio */\n  padding-top: 56.25%;\n  position: relative;\n  margin: 8rem 0;\n}\n\n.vimeoContainer > iframe {\n  border: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.courseHeaderContainer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.courseHeaderContainer > svg {\n  width: 32px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
